import React, {Component} from 'react'
import fire from '../../database/firebase'
import firebase from "firebase/app";
import styled from 'styled-components'
import CountUp from 'react-countup';
import ClipLoader from "react-spinners/ClipLoader";
import { GridLoader } from 'react-spinners'
import { BarLoader } from 'react-spinners'
import Tesseract from 'tesseract.js';
import Slider from "react-slick";
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import copy from 'copy-to-clipboard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CSSTransition } from 'react-transition-group';

const Container = styled.div`
    width: 100%;
    background-color: #321d05;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid white;
    padding-bottom: 2%;
    margin-bottom: 2%;
`;

const Button = styled.button`
    background-color: #007bff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 1px solid white;
    margin-top: 4%;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #321d05;
    color: #fff;
    padding: 10px;
    //   border: 0.7px solid white;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    font-family: sora;
    // border-bottom-left-radius: 1.5%;
    // border-bottom-right-radius: 1.5%;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    height: 100vh:
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: #f1f2f3;
}

.homescreenLoading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 37.5vh; /* This will make the container take the full viewport height */
    text-align: center;
}

    // - - - - - CARD CONTAINER - - - - - //

    // - - - NAVBAR - - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

.dropdown p:hover {
    text-decoration: underline;
}

.cardContainer {
    height: auto;
    width: 100%;
    padding-top: 0.5%;
    padding-bottom: 5%;
    text-align: center;
    background-color: #321d05;
    border-bottom-left-radius:7.5%;
    border-bottom-right-radius: 7.5%;
}

    // - - - CARD UI - - - //

    // - LOYALTY CARD LOADING - //

.userLoyaltyCardLoading {
    padding-top: 25%;
    padding-bottom: 25%;
    text-align: center;
}

    // - CARD - //

.userPointsCard {
    margin: auto;
    width: 92.5%;
    background-color: white;
    height: auto;
    // margin-left: 2.5%;
    border-radius: 10px;
}

.userPointsCard h4 {
    margin-bottom: 0px;
    text-align: left;
    padding: 3%;
    padding-bottom: 1.5%;
    font-family: arvo;
}

.userPointsCard h3 {
    margin-top: 0px;
    text-align: left;
    padding-left: 3%;
    padding-bottom: 2.5%;
    font-weight: bold;
    color: #0930CB;
    font-family: arvo;
    margin-bottom: 0px;
}

.userPointsCardInnerContainer {
    padding-bottom: 0%;
}

.userPointsCardInnerContainer:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardIcon {
    text-align: center;
    width: 25%;
    float: left;
}

.userPointsCardDetails {
    text-align: left;
    width: 75%;
    float: left;
}

.userPointsCardIcon img {
    // width: 100%;
    height: 55px;
    height: 55px;
    border: 3.5px solid #0930CB;
    padding: 7%;
    border-radius: 50%;
    margin-bottom: 0px;
    margin-left: 5%;
}   

.userPointsCardDetails h1 {
    margin-top: 4.5%;
    font-family: Arvo;
    font-weight: bold;
    margin-bottom: 0px;
    margin-left: 3.5%;
}

.userPointsCardDetails p {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 4.5%;
    font-family: gabarito;
    font-weight: bold;
}

.userPointsCardFooter {
    margin-bottom: 0px;
}

.userPointsCardFooter:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardLogo {
    text-align: left; 
    width: 50%;
    float: left;
}

.userPointsCareNumber {
    text-align: right; 
    width: 50%;
    float: left;
}

.userPointsCardLogo img {
    width: 60%;
    margin-top: 0px;
    margin-left: 5%;
    paddingBottom: 1%;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.userPointsCardNumber p {
    font-size: 18.5px;
    margin-right: 6.5%;
    text-align: right;
    padding-bottom: 3%;
    margin-top: 1%;
    font-family: kanit;
}

    // - - - - - EARNING POLICY CONTAINER  - - - - - //

@keyframes blob {
    0% {
        border-radius: 50%;
        transform: scale(1);
    }
    50% {
        border-radius: 10%;
        transform: scale(1.2);
    }
    100% {
        border-radius: 50%;
        transform: scale(1);
    }
}


.earningPolicyContainer2 {
    text-align: center;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    margin: auto;
    margin-top: 5%;
    width: 90%;
    border-radius: 20px;
    border: 1.5px solid #0930cb;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.earningPolicyContainer2 button {
    margin-top: 7.5%;
    // margin-bottom: 7.5%;
    padding: 4.5%;
    background-color: #0930cb;
    color: white;
    font-family: gabarito;
    border: 2px solid #0930cb;
    border-radius: 8px;
    font-size: 85%;
}

.earningPolicyContainer {
    position: relative;
    overflow: hidden;
    background-color: #0930cb;
    margin: auto;
    margin-top: 5%;
    width: 90%;
    border-radius: 20px;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.blob {
    position: absolute;
    width: 3px; /* Adjust the width */
    height: 3px; /* Adjust the height */
    background-color: #fff; /* Blob color */
    border-radius: 50%; /* Make it a circle */
    animation: blob 4s infinite ease-in-out; /* Adjust the duration as needed */
}
  
.blob:nth-child(1) {
    left: 10%;
    top: 20%;
}

.blob:nth-child(2) {
    left: 30%;
    top: 50%;
}

.earningPolicyContainer:after {
    content: "";
    clear: both;
    display: table;
}

.earningPolicyTopMsg p {
    text-align: center;
    padding-top: 0px;
    // margin-top: 0px;
    margin-bottom: 1%;
    font-family: gabarito;
    color: #fff;
    // font-weight: bold;
}

.earningPolicyBottomMsg p {
    // margin-left: 5%;
    // margin: 1% 0; /* Adjust these values as needed */
    // padding: 0;
    // font-family: gabarito;
    // color: #0930cb;
    // font-weight: bold;
}

.earningPolicyImg {
    float: left;
    width: 15%;
    text-align: right;
}

.earningPolicyInfo {
    float: left;
    width: 85%;
    text-align: left; 
    // display: flex;
    // align-items: center;
}

@keyframes levitate {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px); /* Adjust the value to control the levitation distance */
    }
}
  
.levitating-h1 {
    font-size: 2em;
    text-align: center;
    // margin: 0;
    // padding: 10px;
    // border: 2px solid #333;
    display: inline-block;
    animation: levitate 2s infinite ease-in-out; /* Adjust the duration as needed */
}

    // - EARNING POLICY IMG - //

.earningPolicyImg h1 {
    margin-left: 2.5%;
    margin-top: 15%;
    z-index: 9999;
    position: relative;
    // padding-bottom: 5%;
}

    // - EARNING POLICY INFO - //

.earningPolicyInfo button {
    margin-left: 5%;
    background-color: white;
    color: #321d05;
    margin-top: 1.5%;
    padding-top: 1%;
    padding-bottom: 1%;
    padding-left: 3%;
    padding-right: 3%;
    border: 2px solid #fff;
    border-radius: 30px;
    
}

.earningPolicyInfo h1 {
    margin-top: 3.5%;
    margin-bottom: 0px;
    color: #0930cb;
    font-family: sora;
    font-weight: bold;
}

.earningPolicyInfo label {
    font-family: sora;
    color: #0930cb;
    font-size: 17.5px;
    font-weight: bold;
    margin-left: 2%;
    color: white;
}

    // - - - - - EMAIL VERIFICATION  - - - - - //

.emailVerificationLoading {
    text-align: center;
    margin-top: 22.5%;
    margin-bottom: 25%;
}

.emailVerificationContainer {
    margin-top: 6.5%;
    text-align: center;
}

.emailVerificationContainer h4 {
    margin-top: 0px;
    margin-bottom: 1%;
    font-weight: normmal;
    font-family: sora;
}

.emailVerificationContainer img {
    margin-top: 2.5%;
    margin-bottom: 1%;
    width: 10%;
}

.emailVerificationContainer h3 {
    margin-top: 0px;
    color: #0930cb;
    // font-family: gabarito;
    margin-bottom: 0px;
}

.emailVerificationContainer p {
    padding-left: 1.5%;
    padding-right: 1.5%;
}

.verifyEmailBtn {
    background-color: white !important;
    border: 2px solid #0930cb !important;
    color: #0930cb !important;
}

.verifyBtnLoader {
    text-align: center;
    // margin-top: 50%;
}

    // - - - - - UPLOAD RECEIPT - - - - - //

.uploadReceiptContainer {
    margin: auto;
    width: 90%;
    padding-top: 2%;
    padding-bottom: 2%;
    background-color: #321d05;
    border: 2.5px solid #321d05;
    text-align: center;
    border-radius: 8px;
    margin-bottom: 6.5%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.30), 0 6px 15px 0 rgba(0, 0, 0, 0.30);
}

.uploadReceiptContainer h3 {
    margin-bottom: 0px;
    color: #fff;
    font-family: Arvo;
}

.uploadReceiptContainer img {
    margin-top: 2.5%;
    width: 12.5%;
    margin-bottom: 2%;
}

.uploadReceiptContainer p {
    margin-top: 0px;
    font-weight: bold;
    color: #fff;
    font-family: sora;
}

.uploadReceiptContainer button {
    padding: 3%;
    margin-bottom: 5%;
    width: 50%;
    border-radius: 8px;
    border: 2px solid transparent;
    background-color: #f1f2f3;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10), 0 6px 20px 0 rgba(0, 0, 0, 0.10);
    color: #321d05;
    font-family: helvetica;
    // font-weight: bold;
    font-size: 85%;
}

.uploadContainerLoader {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%; /* Ensure the container takes the full height */
    margin-bottom: 10%;
    margin-top: 10%;
}

.captureReceiptFailure p {
    margin-top: 3.5%;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 1.5%;
    font-family: gabarito;
    color: #fff;
}

    // - - - - - INVITATION CARD - - - - - //

.shareCodeContainer {
    text-align: center;
    margin-top: 6.5%;
    margin-bottom: 10%;
}

.shareCodeContainer h3 {
    text-align: left;
    margin-top: 0px;
    // margin-left: 4%;
    font-family: arvo;
    color: #fff;
    padding-left: 3.5%;
    padding-right: 3.5%;
    padding-top: 2.25%;
    padding-bottom: 2.25%;
    border-radius: 12px;
}

.invitationCard {
    // margin-top: 3%;
    width: 90%;
    margin-left: 1%;
    background-color: #f1f2f3;
    border-radius: 8px;
    // border: 1px solid black;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.30), 0 6px 20px 0 rgba(0, 0, 0, 0.30);
    margin-bottom: 4.5%;
    padding: 0.1%;
    height: auto;
    margin: 0 auto;
}

.invitationCard h2 {
    margin-top: 0px;
    text-align: center;
    font-family: Arvo;
    font-weight: bold;
    color: #0930CB;
    padding-top: 5%;
    margin-bottom: 0px;
    font-size: 19.5px
}

.invitationCard p {
    text-align: center;
    padding-left: 3.5%;
    padding-right: 3.5%;
    font-family: Arvo;
    // font-weight: bold;
}

.invitationCardBtn {
    text-align: center;
}

.invitationCard button {
    // margin: auto;
    margin-bottom: 9%;
    width: 70%;
    padding: 3.5%;
    border: 2px solid transparent;
    border-radius: 7px;
    background-color: #0930CB;
    color: white;
    font-family: sora;
    cursor: pointer;
    font-size: 15.5px;
}

    // - - - - - UPCOMING REWARDS CONTAINER - - - - - - //

.upcomingRewardsContainer {
    margin-bottom: 10%;
}

.upcomingRewardsHeader h3 {
    margin-left: 5%;
    text-align: left;
    margin-top: 0px;
    // margin-left: 4%;
    font-family: arvo;
    color: #fff;
    padding-left: 3.5%;
    padding-right: 3.5%;
    padding-top: 2.25%;
    padding-bottom: 2.25%;
    border-radius: 12px;
}

.upcomingRewardsContent h3 {
    // font-family: sora;
    // color: #0930cb;
}  

    // - - REWARD DISPLAY - - //

.upcomingRewardDisplay {
    border-radius: 8px;
    width: 90%;
    height: auto;
    box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.10), 5px 6px 20px 5px rgba(0, 0, 0, 0.10);
}

.upcomingRewardDisplay:after {
    content: "";
    display: table;
    clear: both;
}

.rewardDisplayCol1 {
    float: left;
    width: 25%;
    text-align: center;
}

.rewardDisplayCol2 {
    float: left;
    width: 75%;
    text-align: left;
}

    // - REWARD DISPLAY COL 1 - //

.rewardDisplayCol1 h1 {
    margin-top: 25%;
    font-size: 43px;
    margin-bottom: 1%;
}

.rewardDisplayCol1 span {
    color: #321d05;
}

.rewardDisplayCol1 label {
    font-family: gabarito;
    color: #0930cb;
}

    // - REWARD DISPLAY COL 2 - //

.rewardDisplayCol2 p {
    margin-top: 3%;
    margin-bottom: 0px;
    margin-right: 2.5%;
    font-family: sora;
    font-size: 14px;
}

.rewardDisplayCol2 span {
    margin-top: 1.5%;
    background-color: #321d05;
    padding-left: 2.25%;
    padding-right: 2.25%;
    padding-top: 1.5%;
    padding-bottom: 1.5%;
    border-radius: 5px;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10), 0 6px 20px 0 rgba(0, 0, 0, 0.10);
}

.price-tag::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px 8px 0 8px;
    border-style: solid;
    border-color: #FF914D transparent transparent transparent;
}

.rewardDisplayCol2 h3 {
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
}

.rewardDisplayCol2 h4 {
    font-family: sora;
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
}

    // - - - POINTS NOTIFICATION - - - //

.pointsNotification img {
    width: 10%;
}

    // - - NOTIFICATION CELL - - //

.notificationCell {
    margin-left: 5%;
    margin-right: 5%;
    border-top: 1px solid #FF914D;
}

.notificationCell p {
    font-family: rubik;
    text-align: left;
    margin-left: 1%;
    margin-right: 1%;
}

.notification-enter {
    opacity: 0;
    transform: translateY(100%);
}
  
.notification-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 300ms, transform 300ms;
}
  
.notification-exit {
    opacity: 1;
    transform: translateY(0);
}
  
.notification-exit-active {
    opacity: 0;
    transform: translateY(100%);
    transition: opacity 300ms, transform 300ms;
}

    // - - REWARD DIALOG - - //

    /* CSS Transition Definitions */
    .dialog-slide-enter {
      transform: translateY(100%);
      opacity: 0;
    }
    
    .dialog-slide-enter-active {
      transform: translateY(0);
      opacity: 1;
      transition: transform 500ms, opacity 500ms;
    }
    
    .dialog-slide-exit {
      transform: translateY(0);
      opacity: 1;
    }
    
    .dialog-slide-exit-active {
      transform: translateY(100%);
      opacity: 0;
      transition: transform 500ms, opacity 500ms;
    }

    
    // - - - - - RECENT PURCHASES CONTAINER - - - - - //

.recentPurchasesContainer {
    margin-left: 5%;
    margin-bottom: 10%;
}

.recentPurchasesContent h3 {
    font-family: sora;
    color: #0930cb;
}

    // - - RECENT ACTIVITY - - //

.recentActivityCampaign {
    text-align: center;
    // margin-left: 1%;
    font-weight: bold;
    font-family: helvetica;
    margin-bottom: 5%;
}

.recentActivityCampaign h4 {
    // color: white;
    // margin-bottom: 1%;
}

        // - RECENT ACTIVITY CELL - //

.recentActivityCellCampaignLoading {
    margin-left: 0px;
    text-align: center;
    margin-right: 5%;
    padding-top: 7%;
}

.recentActivityCellCampaign {
    width: 85%;
    height: auto;
    padding-left: 5%;
    background-color: white;
    border-radius: 8px;
    margin-top: 0%;
    // border: 2px solid #0930cb;
    padding-top: 2%;
    padding-right: 2%;
    padding-bottom: 2%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.30), 0 6px 20px 0 rgba(0, 0, 0, 0.30);
    margin-bottom: 5%;
}

.recentActivityCellCampaign:after {
    content: "";
    display: table;
    clear: both;
}

.recentActivityImgCampaign {
    text-align: left;
    width: 15%;
    float: left;
}

.recentActivityDetailsCampaign {
    text-align: left;
    width: 60%;
    float: left;
}

.recentActivityTimestampCampaign {
    text-align: center;
    width: 25%;
    float: left;
}

.recentActivityImgCampaign img {
    margin-top: 10.5%;
    margin-bottom: 5%;
    height: 35px;
    width: 35px;
    border-radius: 50%;
    border: 2.5px solid #0930cb;
    padding: 11.5%;
}

.recentActivityDetailsCampaign h5 {
    margin-left: 8.5%;
    margin-top: 1%;
    font-weight: bold;
    font-size: 12.5px;
    color: #228300;
    margin-bottom: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.recentActivityDetailsCampaign p {
    margin-left: 6.5%;
    margin-top: 0px;
    font-weight: bold;
    font-size: 12.5px;
    color: #000;
    margin-bottom: 0px;
}

.recentActivityDetailsCampaign label {
    font-family: helvetica;
    color: #0930cb;
    margin-top: 0px;
    margin-left: 9%;
    font-size: 12px;
}

.recentActivityTimestampLabel {
    margin-top: 2% !important;
    margin-left: 8.5% !important;
    font-family: Helvetica;
    color: #0930cb !important;
    font-size: 12px !important;
    margin-bottom: 0px !important;
}

.recentActivityTimestampCampaign h4 {
    // display: flex;
    // align-items: center;
    font-size: 12.5px;
    margin-top: 27.5%;
    font-family: arvo;
    color: #0930cb;
    font-weight: bold;
}


    // - - - - - LATEST OFFERS CONTAINER - - - - - //

.latestOffersContainer {
    margin-left: 2%;
    margin-bottom: 10%;
}

.latestOffersContent h3 {
    font-family: arvo;
    color: #0930cb;
}

    // - - OFFER CARDS - - //

.offerCardContainer {
    padding-bottom: 5%;
}

.offerCard {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 90%;
    // float: left;
    border-radius: 10px;
    // margin-right: 5%;
    background-color: #321d05;
    margin: auto;
    margin-right: 6.5%;
    padding-top: 3%;
}

.offerCard h2 {
    text-align: center;
    font-size: 27px;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    margin-bottom: 6%;
}

.offerCardLabel {
    width: 100%;
    background-color: #FF914D;
    padding-top: 5%;
    padding-bottom: 5%;
}

.offerCardLabel label {
    font-family: arvo;
    font-weight: bold;
    font-size: 18px;
}

.offerCardBtn button {
    margin-top: 5.5%;
    width: 45%;
    background-color: #ff;
    font-family: sora;
    padding: 3%;
    color: #321d05;
    border: 2px solid transparent;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
}

.offerCard p {
    text-align: center;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    font-size: 15px;
}

.offerCard span {
    margin-right: 2%;
}

.offerCard h4 {
    margin-top: 5%;
    font-family: arvo;
    font-weight: bold;
    font-size: 20px;
    color: white;
    margin-bottom: 5.5%;
}

.offerCard img {
    width: 100%;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

    // - - PREVIEW OFFER CARD MORE INFO - - //

.previewOfferCardMoreInfo {
    margin-left: 3.5%;
    // margin: auto;
    // position: relative;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.30), 0 6px 20px 0 rgba(0, 0, 0, 0.30);
    // text-align: left;
    width: 91%;
    border-radius: 10px;
    // margin-right: 5%;
    background-color: #fff;
    height: 500px;
    padding-top: 3%;
    padding-bottom: 2%;
}

.previewOfferCardMoreInfo h3 {
    margin-top: 0px;
    padding-top: 2%;
    text-align: left;
    margin-left: 3%;
    font-family: sora;
    color: #321d05;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1.5%;
}

.previewOfferCardMoreInfo textarea {
    margin-left: 2%;
    width: 92.5%;
    height: 375px;
    resize: none;
    padding: 1.5%;
    outline: none;
    font-family: gabarito;
    font-size: 19px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom: 1px solid #321d05;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-top: 1px solid transparent;
    cursor: auto;
    overflow-y: scroll;
}

.previewOfferCardMoreInfo button {
    // position: absolute;
    // bottom: 5%;  
    padding: 3%;
    padding-left: 5%;
    padding-right: 5%;
    width: 25%;
    font-size: 85%;
    background-color: #321d05;
    color: white;
    font-family: sora;
    border: 2px solid #321d05;
    border-radius: 6px;
    // font-weight: bold;
    cursor: pointer;
}

    // - - PREVIEW OFFER CARD LOADING - - //

.previewOfferCardLoading {
    text-align: center;
    padding-top: 65%;
}


    // - - - - - MORE OPTIONS CONTAINER - - - - - //

.moreOptionsContainer {
    margin-bottom: 10%;
}

.moreOptionsContent {
    margin-left: 5%;
}

.moreOptionsHeader h3 {
    text-align: left;
    margin-top: 0px;
    // margin-left: 4%;
    font-family: arvo;
    color: #fff;
    padding-left: 3.5%;
    padding-right: 3.5%;
    padding-top: 2.25%;
    padding-bottom: 2.25%;
    border-radius: 12px;
}

    // - - CHALLENGES CONTAINER - - //

.challengesContainer {
    margin-top: 1.5%;
    margin-bottom: 3%;
}

.challengesContainer:after {
    content: "";
    display: table;
    clear: both;
}

.challengeBox {
    height: auto;
    float: left;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    text-align: left;
    width: 44.5%;
    // margin-right: 5%;
    // float: left;
    // margin-left: 0.5%;
    // margin-bottom: 7.5%;
}

.challengeBox:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox h2 {
    margin-top: 2.5%;
    margin-left: 5%;
    padding-top: 2%;
}

.challengeBox p {
    margin-top: 3%;
    margin-left: 5%;
    font-family: sora;
    font-size: 90%;
    margin-bottom: 2.5%;
    padding-top: 10%;
    padding-bottom: 3%;
}

        // - - - - - FOOTER - - - - - //

.footer {
    width: 100%;
    height: 5%;
    // position: absolute;
    bottom: 0;
    background-color: #321d05;
    // margin-top: 20%;
    text-align: center;
    margin-bottom: 0px;
    border-top-right-radius: 50px;
    border-top-left-radius: 50px;
    border-bottom: 2px solid #321d05;
}

.footer p {
    padding-top: 5%;
    padding-bottom: 5%;
    margin-top: 5%;
    color: #fff;
}

`

export default class SmallPhone extends Component {
    constructor() {
        super()
        this.state = {
            currentClient: "",
            email: "",
            emailVerificationStatus: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            points: 0,
            pointsTillNextReward: "",
            cardNumber: "",
            userID: "",
            invoiceNumber: "",
            dateOfIssue: "",
            earningPolicy: "",
            pointsNotificationCount: 0,
            rewardsNotificationCount: 0,
            earningPolicyPointsValue: "",
            earningPolicyMoneyValue: "",
            earningPolicyEndDate: "",
            earningPolicyPercentageChange: "",
            availableEarningPolicies: [],
            emailVerificationBoxShadow: "0, 0, 0, 0.25",

            //* - - NOTIFICATIONS - - *//

            showPointsNotifications: false,
            showPointsNotificationCount: false,
            showPointsNotificationLoading: false,
            showPointsNotificationClose: false,
            showRewardsNotifications: false,
            showRewardsNotificationCount: false,
            showRewardsNotificationLoading: false,
            showRewardsNotificationClose: false,
            pointsNotifications: [],
            rewardsNotifications: [],

            //* - - REWARDS - - *//

            availableRewards: [],
            showRewardSelected: false,
            rewardHeader: "Redeem",
            rewardsArrayLoading: true,
            showDialogReward: false,
            showDialogRewardLoading: true,
            showDialogRewardSuccess: false,
            showDiscountPrice: true,
            showRedeemBtn: true,
            showRedeemBtnLoading: false,
            showRedeemConfirmBtns: false,
            rewardTitle: "",
            rewardPrice: "",
            discountPrice: "",
            rewardEmoji: "",
            rewardTag: "",
            rewardDate: "",
            rewardDateAndTime: "",
            rewardName: "",
            rewardType: "",
            rewardPointsValue: 0,
            customRewardValue: "",

            steakEmoji: "🥩",
            cocktailEmoji: "🍹",
            pizzaEmoji: "🍕",
                // BAKERY 
            croissantEmoji: "🥐",
            muffinEmoji: "🧁",
            cookieEmoji: "🍪",
            cakeEmoji: "🍰",
            pastryEmoji: "🥮",
            sausageEmoji: "🌭",
            specialBreadEmoji: "🥖",
            bagelEmoji: "🥯",
            regularBreadEmoji: "🍞",
            chocolateEmojit: "🍫",
            pieEmoji: "🥧",

            beerEmoji: "🍺",

            avocadoEmoji: "🥑",
            eggEmoji: "🍳",
            waffleEmoji: "🧇",
            baconEmoji: "🥓",
            fruitEmoji: "🍍",
            bowlEmoji: "🥣",
            salmonEmoji: "🍣",

            burgerEmoji: "🍔",
            iceCreamEmoji: "🍨",
            chipsEmoji: "🍟",
            coffeeEmoji: "☕️",
            teaEmoji: "🫖",
            juiceEmoji: "🥤",
            icedDrinkEmoji: "🧋",
            chickenEmoji: "🍗",
            fishEmoji: "🍤",
            dishEmoji: "🥘",
            pastaEmoji: "🍝",
            wineEmoji: "🍷",
            liquorEmoji: "🥃",
            sandwichEmoji: "🥪",
            customRewardEmoji: "🎁",

            //* - - USER LOYALTY CARD - - *//

            userLoyaltyCardBgColor: "",
            userLoyaltyCardShowPointsRemaining: false,
            userLoyaltyCardShowCardNumber: true,

            //* - - INVITATION CARDS - - *//

            invitationCardHeader: "",
            invitationCardText: "",

            //* - - OFFER CARDS - - *//

            showOfferCard1: false,
            showOfferCard1Loading: false,
            showOfferCard1MoreInfo: false,
            showOfferCard1MoreInfoLoading: false,
            showOfferCard2: false,
            showOfferCard2Loading: true,
            showOfferCard2MoreInfo: false,
            showOfferCard2MoreInfoLoading: false,
            showOfferCard3: false,
            showOfferCard3Loading: true,
            showOfferCard3MoreInfo: false,
            showOfferCard3MoreInfoLoading: false,
            firstPromoText: "",
            firstPromoSubtext: "",
            firstPromoMiniText: "",
            firstPromoImg: "",
            firstPromoMoreInfoText: "",
            secondPromoText: "",
            secondPromoSubtext: "",
            secondPromoMiniText: "",
            secondPromoImg: "",
            secondPromoMoreInfoText: "",
            thirdPromoText: "",
            thirdPromoSubtext: "",
            thirdPromoMiniText: "",
            thirdPromoImg: "",
            thirdPromoMoreInfoText: "",

            isOnline: false,
            isNavOpen: false, // Initially, navigation is closed
            isDropdownOpen: false,
            showHomeScreen: false,
            showHomeScreenLoading: true,
            showConfirmVerificationBtnText: true,
            showConfirmVerificationBtnLoading: false,
            showUserLoyaltyCard: false,
            showUserLoyaltyCardLoading: true,
            showRecentActivityCard: true,
            showRecentActivityCardLoading: false,
            recentActivityTimestamp: "05/11/23, 09:52"
        }
    }

    componentDidMount = () => {
        const url = window.location.href
        const parts = url.split('/'); // Split the URL by '/'
        const lastPart = parts[parts.length - 1]; // Get the last part
        this.setState({
            currentClient: lastPart
        })
        this.loadHomescreen(lastPart)
        // this.loadRewards()
        // this.loadEarningPolicies()
    }

    componentWillUnmount() {
        // Unsubscribe from the listener when the component is unmounted
        if (this.pointsListener) {
            this.pointsListener();
        }
    }

    loadUserLoyaltyCardData = async () => {
       await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("leftSidePane")
        .doc("customerInformation")
        .collection("cardInformation")
        .doc("design")
        .get().then(doc => {
            if (doc.data().showPointsRemaining === true) {
                
            }
            this.setState({
                userLoyaltyCardBgColor: doc.data().backgroundColor,
                userLoyaltyCardShowCardNumber: doc.data().showUserCardNumber,
                userLoyaltyCardShowPointsRemaining: doc.data().showPointsRemaining
            })
        })
    }

    updateLastActiveMembers = (year, month, day) => {

        const promises = []

        let lastActiveYearRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("activity")
        .collection("lastActive")
        .doc(year)
        .collection("allMembers")
        .doc(this.state.userID)

        let lastActiveYearPromise = lastActiveYearRef.get().then(doc => {
            if (doc.exists) {
                
            } else {

            }
        })



    }

    
    loadInvitationCardData = async () => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("leftSidePane")
        .doc("customerInformation")
        .collection("referralInformation")
        .doc("text")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    invitationCardHeader: doc.data().invitationCardHeader,
                    invitationCardText: doc.data().invitationCardText
                })
            }
        })
    }

    loadOfferCardsData = async () => {

            //* - - OFFER CARD 1 - - *//

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard1")
        .doc("publishingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    firstPromoText: doc.data().promoHeader,
                    firstPromoSubtext: doc.data().promoSubheader,
                    firstPromoMiniText: doc.data().promoMiniText,
                    firstPromoMoreInfoText: doc.data().promoMoreInfo,
                    firstPromoImg: doc.data().promoImg
                })
            }
        })
        .then(() => {
            this.setState({
                showOfferCard1Loading: false,
                showOfferCard1: true
            })
        })

            //* - - OFFER CARD 2 - - *//

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard2")
        .doc("publishingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    secondPromoText: doc.data().promoHeader,
                    secondPromoSubtext: doc.data().promoSubheader,
                    secondPromoMiniText: doc.data().promoMiniText,
                    secondPromoMoreInfoText: doc.data().promoMoreInfo,
                    secondPromoImg: doc.data().promoImg
                })
            }
        })
        .then(() => {
            this.setState({
                showOfferCard2Loading: false,
                showOfferCard2: true
            })
        })

            //* - - OFFER CARD 3 - - *//

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("campaigns")
        .collection("homePage")
        .doc("offerCards")
        .collection("offerCard3")
        .doc("publishingData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    thirdPromoText: doc.data().promoHeader,
                    thirdPromoSubtext: doc.data().promoSubheader,
                    thirdPromoMiniText: doc.data().promoMiniText,
                    thirdPromoMoreInfoText: doc.data().promoMoreInfo,
                    thirdPromoImg: doc.data().promoImg
                })
            }
        })
        .then(() => {
            this.setState({
                showOfferCard3Loading: false,
                showOfferCard3: true
            })
        })
    }

    loadHomescreen = async (client) => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                fire.firestore().collection("clients")
                .doc(client)
                .collection("members")
                .doc("members_list")
                .collection("email_list")
                .doc(user.email)
                .get().then(async doc => {
                    if (doc.exists) {
                        this.setState({
                            isOnline: true,
                            userID: doc.data().id,
                            phoneNumber: doc.data().number
                        })
                        await this.loadOfferCardsData()
                        await this.loadInvitationCardData()
                        await this.loadUserLoyaltyCardData()
                        await this.loadRewards()
                        await this.loadDatabaseInformation(client, doc.data().id)
                    }
                })
            } else {
                console.log("We failed dawg")
                this.setState({user:null})
            }
        })
        this.setState({
            showHomeScreen: false,
            showUserLoyaltyCard: false,
            showUserLoyaltyCardLoading: true,
            showHomeScreenLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showUserLoyaltyCardLoading: false,
                showHomeScreenLoading: false,
                showUserLoyaltyCard: true,
                showHomeScreen: true
               })
            }, 3000)
        })
    }

    loadNotificationCount = async (userID) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("notifications")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    pointsNotificationCount: doc.data().pointsNotificationCount,
                    rewardsNotificationCount: doc.data().rewardsNotificationCount
                })
                if (doc.data().pointsNotificationCount > 0) {
                    this.setState({
                        showPointsNotificationCount: true
                    })
                }
                if (doc.data().rewardsNotificationCount > 0) {
                    this.setState({
                        showRewardsNotificationCount: true
                    })
                }

            }
        })
    }

    checkForOrdersPendingVerification = async (userID) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("nonVerified")
        .get().then(snapshot => {
            if (snapshot.size > 0) {
                this.setState({
                    showMyOrdersNotification: false,
                    showReceiptVerificationPending: true
                })
            } else {
                this.setState({
                    showReceiptVerificationPending: false
                })
            }
        })
    }

    checkLatestRewardDate = async (userID) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .get().then(doc => {
            if (doc.exists) {
                if (doc.data().newReward === "true") {
                    const memberNotificationRef = fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(userID)
                    .collection("data")
                    .doc("notifications")

                    memberNotificationRef.get().then(doc2 => {
                        if (doc2.exists) {
                            if (this.isDateBeforeOnly(doc2.data().latestReward, doc.data().latestReward)) {
                                memberNotificationRef.update({
                                    seenNewReward: "false",
                                    clickedNewReward: "false",
                                    latestReward: doc.data().latestReward
                                })
                            }
                        }
                    })
                    
                }
            }
        })
    }

    checkForNewRewardsAdded = async (userID) => {
        this.checkLatestRewardDate(userID)
        setTimeout(() => {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("rewards")
            .get().then(doc => {
                if (doc.exists) {
                    if (doc.data().newReward === "true") {
                        fire.firestore().collection("clients")
                        .doc("artcaffe")
                        .collection("members")
                        .doc("members_list")
                        .collection("list")
                        .doc(userID)
                        .collection("data")
                        .doc("notifications")
                        .get().then(doc => {
                            if (doc.exists) {
                                if (doc.data().clickedNewReward === "false") {
                                    this.setState({
                                        showMoreRewardsNotification: true
                                    })
                                }
                                if (doc.data().seenNewReward === "false") {
                                    this.pushNewRewardNotification()
                                }
                            }
                        })
                        
                    }
                }
            })
        }, 1000)
    }

    pushNewRewardNotification = () => {
        fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("notifications")
            .collection("rewards")
            .doc("notification-0000") 
            .get().then(async doc => {
                if (!doc.exists) {
                    const notificationCountRef = fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("notifications")
        
                    await notificationCountRef.get().then(doc => {
                        if(doc.exists) {
                            const currentNotificationCount = doc.data().rewardsNotificationCount
                            const updatedNotificationCount = currentNotificationCount+1
                            notificationCountRef.update({
                                rewardsNotificationCount: updatedNotificationCount
                            })
                        }
                    })
                    this.loadNotificationCount(this.state.userID)
                } 
            })
        .then(() => {
            const rewardNotificationRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("notifications")
            .collection("rewards")
            .doc(`notification-0000`)

            rewardNotificationRef.get().then(doc => {
                if (doc.exists) {
                    rewardNotificationRef.update({
                        msg: `We've added a new reward! Go to 'More Rewards' to find out more details 👀`
                    })
                } else {
                    rewardNotificationRef.set({
                        msg: `We've added a new reward! Go to 'More Rewards' to find out more details 👀`,
                        date: this.formatDate2(new Date()).slice(0, -3)
                    })
                }
            })
        })
    }

    loadDatabaseInformation = async (client, userID) => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;

        let getRef = fire.firestore().collection("clients")
        .doc(client)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        getRef.get().then(async doc => {
            if (doc.exists) {
                    //* - - CHECK FOR EMAIL VERIFICATION - - //
                let user = fire.auth().currentUser
                if (user && user.emailVerified && doc.data().emailVerified == "pending") {
                    this.setState({
                        emailVerificationStatus: doc.data().emailVerified,
                        showEmailVerificationLoading: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showEmailVerificationLoading: false,
                                showEmailVerificationSuccess: true
                            })
                        }, 5000)
                    })
                } else if (user && user.emailVerified && doc.data().emailVerified == "success") {
                    this.setState({
                        showEmailVerificationLoading: false,
                        showEmailVerificationSuccess: false,
                        showUploadReceipts: true,
                        showUploadReceiptUploading: false,
                        showUploadReceiptLoading: false,
                        showUploadReceiptSuccess: false,
                        showUploadReceiptFailure: false,
                        uploadReceiptErrorMessage: "",
                    })
                    await this.loadEarningPolicies()
                    await this.loadNotificationCount(userID)
                    await this.checkForOrdersPendingVerification(userID)
                    await this.checkForNewRewardsAdded(userID)
                    this.checkIfEarningPoliciesApply()
                    // setTimeout(() => {
                    //     this.createBlobs();
                    // }, 10000)
                    
                } else {
                    if (doc.data().emailVerified == "false") {
                        this.setState({
                            emailVerificationStatus: doc.data().emailVerified,
                            showEmailVerificationLoading: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    showEmailVerificationLoading: false,
                                    showEmailVerification: true
                                })
                            }, 5000)
                        })
                    } else if (doc.data().emailVerified == "pending") {
                        this.setState({
                            emailVerificationStatus: doc.data().emailVerified,
                            showEmailVerificationLoading: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    showEmailVerificationLoading: false,
                                    showEmailVerificationPending: true
                                })
                            }, 5000)
                        })
                    }
                }
    
                    //* - - GET PROFILE INFORMATION - - *//
                let userEmail = doc.data().email
                this.setState({
                    firstName: doc.data().firstName,
                    lastName: doc.data().lastName,
                    cardNumber: doc.data().cardNumber,
                    email: userEmail.toLowerCase()
                })
                    //* - - VERIFY USER & REGISTRATION DATE - - *//
                if (doc.data().verified == false) {
                    getRef.update({
                        verified: true,
                        registrationDate: formattedDateTimeWithAmPm
                    })
                }
                    //* - - UPDATE LATEST ACTIVITY - - *// (every time the user lands on the page - in case they never log out)
                getRef.update({
                    lastActive: formattedDateTimeWithAmPm
                })

                    //* - - GET CARD INFORMATION - - *//
                fire.firestore().collection("clients")
                .doc(client)
                .collection("members")
                .doc("members_list")
                .collection("list")
                .doc(userID)
                .collection("data")
                .doc("pointsInfo")
                .get().then(doc => {
                    if (doc.exists) {
                        if (this.state.userLoyaltyCardShowPointsRemaining) {
                            const currentPoints = Math.round(doc.data().points)
                            const differenceToNearestReward = this.findDifferenceToNearestReward(this.state.availableRewards, currentPoints)
                            this.setState({
                                pointsTillNextReward: differenceToNearestReward
                            })
                        }
                        this.setState({
                            points: doc.data().points,
                            // pointsTillNextReward: doc.data().pointsTillNextReward
                        })
                    }
                })
            }
        })
    }

    loadEarningPolicies = async () => {
        class EarningPolicy {
            constructor (endDate, id, moneyValue, percentageChange, pointsValue) {
                this.endDate = endDate
                this.id = id
                this.moneyValue = moneyValue
                this.percentageChange = percentageChange
                this.pointsValue = pointsValue
            }
            toString () {
                return this.endDate + ', ' +
                this.id + ', ' +
                this.moneyValue + ', ' +
                this.percentageChange + ', ' +
                this.pointsValue
            }
        }
        var policyConverter = {
            toFirestore : function (policy) {
                return {
                    endDate: policy.endDate,
                    id: policy.id,
                    moneyValue: policy.moneyValue,
                    percentageChange: policy.percentageChange,
                    pointsValue: policy.pointsValue
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new EarningPolicy(data.endDate, data.id, data.moneyValue, data.percentageChange, data.pointsValue)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("points")
        .collection("earningPolicies")
        .withConverter(policyConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            console.log(data)
            this.setState({
                availableEarningPolicies: data
            })
        })
    }

    formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    }

    checkIfEarningPoliciesApply = async () => {

        let myEarningPolicies = []
        
        let personalEarningPoliciesRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("pointsInfo")
        .collection("earningPolicies")

        for (let i = 0; i < this.state.availableEarningPolicies.length; i++) {
            await personalEarningPoliciesRef.doc(this.state.availableEarningPolicies[i].id).get().then(doc => {
                if (doc.exists) {
                    myEarningPolicies.push(this.state.availableEarningPolicies[i])
                }
            })  
        }

        const sortedArray = myEarningPolicies.sort((a, b) => b.percentageChange - a.percentageChange);
        console.log(sortedArray)

        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

        let validEarningPolicies = []
        for (let i = 0; i < sortedArray.length; i++) {
            if (this.isDateBefore(formattedDate, sortedArray[i].endDate)) {
                validEarningPolicies.push(sortedArray[i])
            }
        }
        
        console.log(validEarningPolicies)

        if (validEarningPolicies[0]) {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("pointsInfo")
            .update({
                earningPolicy: validEarningPolicies[0].id,
                earningPolicyEndDate: validEarningPolicies[0].endDate,
                earningPolicyPointsValue: validEarningPolicies[0].pointsValue,
                earningPolicyMoneyValue: validEarningPolicies[0].moneyValue
            })
            this.setState({
                showEarningPolicyChecking: true,
                earningPolicy: validEarningPolicies[0].id,
                earningPolicyPointsValue: validEarningPolicies[0].pointsValue,
                earningPolicyMoneyValue: validEarningPolicies[0].moneyValue,
                earningPolicyEndDate: validEarningPolicies[0].endDate,
                earningPolicyPercentageChange: validEarningPolicies[0].percentageChange
            }, () => {
                setTimeout(() => {
                   this.setState({
                       showEarningPolicyChecking: false,
                       showEarningPolicy: true
                   })
                }, 3000)
            })
            setTimeout(() => {
                this.createBlobs()
             }, 6000)
        }
    }

    isDateBefore = (date1, date2) => {
        // Convert date strings to Date objects
        const dateObject1 = new Date(date1);
        const dateObject2 = new Date(date2);
    
        // Compare the two dates
        return dateObject1 <= dateObject2;
    }

    isDateBeforeOnly = (date1, date2) => {
        // Convert date strings to Date objects
        const dateObject1 = new Date(date1);
        const dateObject2 = new Date(date2);
    
        // Compare the two dates
        return dateObject1 < dateObject2;
    }

    renderCardNumber = () => {
        const formattedNumber = this.state.cardNumber.replace(/(\d{3})(\d{4})(\d{5})/, '$1 $2 $3');
        return(
            <span>{formattedNumber}</span>
        )
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    dropdownOption2Clicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            
        } else {
            this.toggleDropdown()
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    dropdownOption3Clicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            
        } else {
            this.toggleDropdown()
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    dropdownOption4Clicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            
        } else {
            this.toggleDropdown()
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    handleScrollToEmailVerification = () => {
        const element = document.getElementById('topOfEmailVerification');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    renderRecentActivityCell = () => {
        return (
            <div className='recentActivityCampaign'>
                <div className='recentActivityCellCampaign'>
                    {this.state.showRecentActivityCard && 
                        <div>
                            <div className='recentActivityImgCampaign'>
                                <img src='/assets/recent-activity6.5.gif'/>
                            </div>
                            <div className='recentActivityDetailsCampaign'>
                                <p className='recentActivityTimestampLabel'>{this.state.recentActivityTimestamp}</p>
                                <h5>Halloumi Cheese, Pesto & Antpasti In Farm Bread (KES 1190)</h5>
                                <p>📍The Hub</p>
                            </div>
                            <div className='recentActivityTimestampCampaign'>
                                <h4>
                                    <span></span>
                                    <CountUp
                                        start={0}
                                        end={1000}
                                        duration={2}
                                        useEasing={true}
                                        useGrouping={true}
                                        separator={''}
                                        decimal={'.'}
                                    />
                                    <span> pts</span>
                                </h4>
                            </div>
                        </div>
                    }
                    {this.state.showRecentActivityCardLoading && 
                        <div className='recentActivityCellCampaignLoading'>
                            <ClipLoader
                            color="#0930CB"
                            loading={true}
                            // cssOverride={override}
                            size={25}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }

    pointsRewardsClicked = async () => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .update({
            clickedNewReward: "true"
        })

        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            window.location.href = `/smp-rewards/${this.state.currentClient}`
        } else {
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    challengesClicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            window.location.href = `/smp-challenges/${this.state.currentClient}`
        } else {
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }   
    
    wishListClicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            window.location.href = `/smp-wish-list/${this.state.currentClient}`
        } else {
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    secretMenuClicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            window.location.href = `/smp-secret-menu/${this.state.currentClient}`
        } else {
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    shareReferralCodeClicked = () => {
        let user = fire.auth().currentUser
        if (user && user.emailVerified) {
            //* - - COPY REFERRAL CODE TO CLIPBOARD AND CHANGE UI OF BUTTON - - *//
        } else {
            this.handleScrollToEmailVerification()
            this.setState({
                emailVerificationBoxShadow: "240, 52, 52, 1"
            })
        }
    }

    logout = () => {
        this.setState({
            emailVerificationBoxShadow: "0, 0, 0, 0.25"
        })
        fire.auth().signOut()
        window.location.href = `/login/${this.state.currentClient}`
    }

    verifyEmailClicked = () => {
        this.setState({
            showConfirmVerificationBtnText: false,
            showConfirmVerificationBtnLoading: true,
            emailVerificationBoxShadow: "0, 0, 0, 0.25"
        })
        const user = fire.auth().currentUser;
        user
        .sendEmailVerification()
        .then(() => {
            fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .update({
                emailVerified: "pending"
            })
            this.setState({
                showEmailVerification: false,
                showEmailVerificationLoading: true
            }, () => {
                setTimeout(() => {
                    this.loadDatabaseInformation(this.state.currentClient, this.state.userID)
                }, 1000)
            })
        })
        .catch((error) => {
            
        });
    }

    verifyConfirmationClicked = () => {
        window.location.reload();
    }

    closeEmailVerification = () => {
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .update({
            emailVerified: "success"
        })
        this.setState({
            showEmailVerificationSuccess: false,
            showEmailVerificationLoading: true
        }, () => {
            setTimeout(() => {
                this.loadDatabaseInformation(this.state.currentClient, this.state.userID)
            }, 4000)
        })
    }

    uploadReceiptClicked = () => {
        this.fileInput.click();
    }

    captureReceiptText = async (file) => {
        if (file) {
            this.setState({
                showUploadReceipts: false,
                showUploadReceiptUploading: true,
                uploadingReceiptText: "Checking receipt",
                uploadReceiptDelayText: "(don't refresh or leave this page)"
            })
            try {
                const tesseractPromise = Tesseract.recognize(file, 'eng');
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => {
                        this.setState({
                            uploadReceiptDelayText: "(don't refresh or leave this page)"
                        })
                    }, 10000); // Set the timeout to 45 seconds
                    setTimeout(() => {
                        reject(new Error("Tesseract operation timed out"));
                    }, 20000); // Set the timeout to 45 seconds
                });

                // Use Promise.race to get the result of the first resolved promise
                const { data } = await Promise.race([tesseractPromise, timeoutPromise]);

                let invoiceNumber = this.getReceiptInvoice(data.text)
                let dateOfPurchase = this.getReceiptIssueDate(data.text)

                this.setState({
                    showUploadReceipts: false,
                    showUploadReceiptUploading: true
                }, () => {
                    if (invoiceNumber && dateOfPurchase) {
                        this.setState({
                            invoiceNumber: invoiceNumber,
                            dateOfIssue: dateOfPurchase,
                            showReceiptInvoiceNumber: true,
                            showReceiptDateOfPurchase: true,
                            showReceiptCaptureDisclaimer: true
                        })
                    }
                    setTimeout(() => {
                        this.setState({
                            showUploadReceiptUploading: true,
                            uploadingReceiptText: "Uploading receipt",
                        })
                    }, 2000)
                })
                //* - - GET LOCATION - - *//
                //   Add your further processing logic here
                // if (data.text.includes("THE HUB") || data.text.includes("THE Hug") || data.text.includes("THE Hup") || data.text.includes("[HE HUB")) {
                // let invoiceNumber = this.getReceiptInvoice(data.text)
                // let dateOfPurchase = this.getReceiptIssueDate(data.text)
                //     if (invoiceNumber != null && dateOfPurchase != "") {
                //         //? - - EVERYTHING IS GOOD - - ?//
                //         this.setState({
                //             showUploadReceipts: false,
                //             showUploadReceiptUploading: true,
                //             uploadingReceiptText: "Checking receipt"
                //         }, () => {
                //             setTimeout(() => {
                //                 this.setState({
                //                     showUploadReceiptUploading: true,
                //                     uploadingReceiptText: "Checking receipt",
                //                     invoiceNumber: invoiceNumber,
                //                     dateOfIssue: dateOfPurchase,
                //                     // uploadReceiptErrorMessage: "Coulnd't process receipt",
                //                     // receiptCaptureError1: "Store location not available"
                //                 })
                //             }, 4000)
                //         })
                //     } else {
                //         this.setState({
                //             showUploadReceipts: false,
                //             showUploadReceiptUploading: true
                //         }, () => {
                //             setTimeout(() => {
                //                 this.setState({
                //                     invoiceNumber: data.text,
                //                     showUploadReceiptUploading: false,
                //                     showUploadReceiptFailure: true,
                //                     uploadReceiptErrorMessage: "Coulnd't process receipt",
                //                     receiptCaptureError1: "Don't hold your camera too close to the receipt",
                //                     receiptCaptureError2: "Ensure your picture is bright enough",
                //                     receiptCaptureError3: "Straighten creases on your receipt",
                //                     receiptCaptureError4: "OR store location is not available yet"
                //                 })
                //             }, 4000)
                //         })
                //     }
                // } else {
                //     this.setState({
                //         showUploadReceipts: false,
                //         showUploadReceiptUploading: true
                //     }, () => {
                //         setTimeout(() => {
                //             this.setState({
                //                 dateOfIssue: data.text,
                //                 showUploadReceiptUploading: false,
                //                 showUploadReceiptFailure: true,
                //                 uploadReceiptErrorMessage: "Coulnd't process receipt",
                //                 receiptCaptureError1: "Don't hold your camera too close to the receipt",
                //                 receiptCaptureError2: "Ensure your picture is bright enough",
                //                 receiptCaptureError3: "Straighten creases on your receipt",
                //                 receiptCaptureError4: "OR store location is not available yet"
                //             })
                //         }, 4000)
                //     })
                // }
            } catch (error) {
                this.setState({
                    showUploadReceipts: false,
                    showUploadReceiptUploading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showUploadReceiptUploading: true,
                            uploadingReceiptText: "Uploading receipt",
                            // uploadReceiptErrorMessage: "Coulnd't process receipt",
                            // receiptCaptureError1: "Don't hold your camera too close to the receipt",
                            // receiptCaptureError2: "Ensure your picture is bright enough",
                            // receiptCaptureError3: "Straighten creases on your receipt",
                            // receiptCaptureError4: "OR store location is not available yet"
                        })
                    }, 4000)
                })
            }
            
        }
    };

    getReceiptInvoice = (receipt) => {
        //* - - GET INVOICE NUMBER - - *//
        // Define the pattern to match substrings of ONLY numbers
        const regex3 = /\b\d+\b/g;
        // Use the regular expression to find all substrings of ONLY numbers
        const matches2 = receipt.match(regex3);
        // Find the longest substring
        const longestSubstring = matches2 ? matches2.reduce((a, b) => (a.length >= b.length ? a : b), '') : null;
        // Return null if the longest substring is less than 8 characters
        const result = longestSubstring.length < 10 ? null : longestSubstring;
        return result
    }

    getReceiptIssueDate = (receipt) => {
        //* - - GET DATE SUBSTRING - - *//
        // Define the pattern to match the date format DD/MM/YY
        const regex = /\b\d{1,2}\/\d{1,2}\/\d{2}\b/g;
        // Use the regular expression to extract the date
        const matches = receipt.match(regex);
        // Extracted date values will be in the matches array
        const extractedDates = matches ? matches : [];
        // Define the pattern to match the desired substring
        const regex2 = /\b(\d{2}:\d{2}.+?)\b/;
        // Use the regular expression to find the first occurrence of the substring
        const match = receipt.match(regex2);
        // Extracted substring will be in match[1] (if there is a match)
        const extractedSubstring = match ? match[1] : null;
        const firstFiveCharacters = extractedSubstring ? extractedSubstring.slice(0, 5) : "";
        let finalDateString = `${extractedDates} ${firstFiveCharacters}`
        finalDateString = finalDateString.replace(/(\d{2}\/\d{2}\/\d{2})(?:,\1)+/g, '$1');
        return finalDateString
    }

    compressAndUploadImage = (file, storageRef) => {
        let errorMessage = '';
        const maxSize = 1024; // Maximum size in kilobytes
        const reader = new FileReader();

        let uploadSuccessful = false
    
        return new Promise((resolve, reject) => {
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
    
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
    
                    // Calculate the new size to fit within the maxSize
                    const scaleFactor = Math.min(maxSize / img.width, maxSize / img.height);
                    canvas.width = img.width * scaleFactor;
                    canvas.height = img.height * scaleFactor;
    
                    // Draw the image on the canvas
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    
                    // Convert the canvas to a data URL with specified quality
                    const compressedDataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality as needed
    
                    // Convert data URL to a Blob
                    const byteCharacters = atob(compressedDataURL.split(',')[1]);
                    const byteNumbers = new Array(byteCharacters.length);
    
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
    
                    const byteArray = new Uint8Array(byteNumbers);
                    const compressedBlob = new Blob([byteArray], { type: 'image/jpeg' });
    
                    // Upload the compressed image to Firebase Storage
                    const uploadTask = storageRef.put(compressedBlob);
    
                    uploadTask.on(
                        'state_changed',
                        (snapshot) => {
                            this.setState({
                                showUploadReceipts: false,
                                showUploadReceiptUploading: true,
                            });
                            console.log("trying upload - state changed")
                            setTimeout(() => {
                                if (!uploadSuccessful) {
                                    this.setState({
                                        showUploadReceiptUploading: false,
                                        showUploadReceiptFailure: true,
                                        uploadReceiptErrorMessage: "Upload timed out. Check internet connection."
                                    })
                                }
                            }, 30000);
                        },
                        (error) => {
                            setTimeout(() => {
                                this.setState({
                                    showUploadReceiptUploading: false,
                                    showUploadReceiptFailure: true,
                                    uploadReceiptErrorMessage: errorMessage
                                });
                            }, 4000); 
                        },
                        () => {
                            const timeoutPromise = new Promise((_, rejectTimeout) => {
                                console.log("timeout started")
                                const timeoutDuration = 30000; // 40 seconds
                                setTimeout(() => {
                                    if (!uploadSuccessful) {
                                        this.setState({
                                            showUploadReceiptUploading: false,
                                            showUploadReceiptFailure: true,
                                            uploadReceiptErrorMessage: "Upload timed out. Check internet connection."
                                        })
                                    }
                                    rejectTimeout(new Error('Upload timed out. Check internet connection.'));
                                }, timeoutDuration);
                            });
                            // Use Promise.race to handle either upload completion or timeout
                            Promise.race([
                                storageRef.getDownloadURL().then((result) => {
                                    console.log("we got the download link")
                                    uploadSuccessful = true;
                                    return result
                                }).catch(error => error),
                                timeoutPromise,
                            ])
                            .then((result) => {
                                resolve(result);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                        }
                    );
                };
            };
            reader.readAsDataURL(file);
        });
    };

    handleReceiptImageUpload = async (file) => {
        const currentDate = new Date();

        // Get individual date components
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const day = currentDate.getDate().toString().padStart(2, '0');

        // Get individual time components
        const hours = currentDate.getHours().toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');

        // Combine date and time components without dashes
        const receiptStorageID = `receipt-${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
        const formattedDate = `${year}-${month}-${day} ${hours}-${minutes}`

        const storage = fire.storage();
        const storageRef = storage.ref();
        const imageRef = storageRef.child(`clients/artcaffe/admin/transactions/receipts/${this.state.userID}/${receiptStorageID}`);
    
        await this.captureReceiptText(file)

        this.compressAndUploadImage(file, imageRef)
        .then( async (downloadURL) => {
            try {

                let promisesFulfilled = false;

                const uploadPromises = [
                    this.uploadReceiptAdminSide(receiptStorageID, formattedDate, downloadURL),
                    this.uploadReceiptCustomerSide(receiptStorageID, formattedDate, downloadURL)
                ];
    
                // Add a timeout for the overall Promise.all
                const timeoutPromise = new Promise((_, rejectTimeout) => {
                    const timeoutDuration = 30000; // 30 seconds
                    setTimeout(() => {
                        if (!promisesFulfilled) {
                            rejectTimeout(new Error('Promise.all timed out.'));
                        }
                    }, timeoutDuration);
                });
    
                await Promise.race([
                    Promise.all(uploadPromises)
                        .then(() => {
                            promisesFulfilled = true;
                        }),
                    timeoutPromise
                ]);
    
                if (promisesFulfilled) {
                    this.setState({
                        showUploadReceiptUploading: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showUploadReceiptUploading: false,
                                showUploadReceiptSuccess: true,
                            });
                        }, 6000);
                    });
                } else {
                    let errorMessage = "An error occurred during upload.";
                    this.setState({
                        showUploadReceiptUploading: false,
                        showUploadReceiptFailure: true,
                        uploadReceiptErrorMessage: errorMessage,
                        receiptCaptureError1: "Check your internet connection"
                    });
                }
            } catch (error) {
                // Handle errors from compressAndUploadImage or upload functions
                console.error('Error during image upload:', error);
    
                let errorMessage = "An error occurred during upload.";
                this.setState({
                    showUploadReceiptUploading: false,
                    showUploadReceiptFailure: true,
                    uploadReceiptErrorMessage: errorMessage,
                    receiptCaptureError1: "Check your internet connection"
                });
            }
            // //* - - ADD IF STATEMENT TO DETERMINE LOCATION - - *//
        })
        .catch((error) => {
            let errorMessage = "An error occurred during upload.";
            this.setState({
                showUploadReceiptUploading: false,
                showUploadReceiptFailure: true,
                uploadReceiptErrorMessage: errorMessage,
                receiptCaptureError1: "Check your internet connection"
            });
        })
    }

    uploadReceiptAdminSide = async (receiptID, date, imgURL) => {
        await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("transactions")
            .doc("locations")
            .collection("the_hub")
            .doc("nonVerified")
            .collection("list")
            .doc(`${receiptID}-${this.state.userID}`)
            .set({
                backgroundColor: "white",
                receiptImg: imgURL,
                uploadTime: date,
                userID: this.state.userID,
                name: `${this.state.firstName} ${this.state.lastName}`,
                location: "The Hub",
                receiptID: receiptID,
                email: this.state.email,
                cardNumber: this.state.cardNumber,
                invoiceNumber: this.state.invoiceNumber,
                dateOfPurchase: this.state.dateOfIssue,
                earningPolicy: this.state.earningPolicy,
                earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                earningPolicyPercentageChange: this.state.earningPolicyPercentageChange,
                earningPolicyEndDate: this.state.earningPolicyEndDate
            })
        .then(() => {
            console.log(".then admin data upload")
            fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("transactions")
            .doc("locations")
            .collection("the_hub")
            .doc("nonVerified")
            .collection("orderList")
            .doc(`${receiptID}-${this.state.userID}`)
            .set({
                orderCount: 0
            })
            .catch((error) => {
                this.setState({
                    showUploadReceiptUploading: false,
                    showUploadReceiptFailure: true,
                    uploadReceiptErrorMessage: "Upload failed. Check internet connection.",
                    uploadReceiptDelayText: ""
                })
            })
        })
        .catch((error) => {
            this.setState({
                showUploadReceiptUploading: false,
                showUploadReceiptFailure: true,
                uploadReceiptErrorMessage: "Upload failed. Check internet connection.",
                uploadReceiptDelayText: ""
            })
        })
    }

    uploadReceiptCustomerSide = async (receiptID, date, imgURL) => {
        console.log("try customer data upload")
        await fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("nonVerified")
        .doc(receiptID)
        .set({
            receiptImg: imgURL,
            uploadTime: date,
            userID: this.state.userID,
            location: "",
            receiptID: receiptID,
            adminMsg: "",
            verified: false
        })
        .then(() => {
            this.pushReceiptUploadedNotification()
        })
        .catch((error) => {
            console.log("CUSTOMER ERROR")
            this.setState({
                showUploadReceiptUploading: false,
                showUploadReceiptFailure: true,
                uploadReceiptErrorMessage: "Upload failed. Check internet connection.",
                uploadReceiptDelayText: ""
            })
        })
    }

    pushReceiptUploadedNotification = () => {
        const receiptNotificationRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("points")
        .doc(`notification-${this.state.pointsNotificationCount+1 || 1}`)

        receiptNotificationRef.get().then(doc => {
            if (doc.exists) {
                receiptNotificationRef.update({
                    msg: "Your order information is being reviewed. Check back later for a new notification once our review is complete."
                })
            } else {
                receiptNotificationRef.set({
                    msg: "Your order information is being reviewed. Check back later for a new notification once our review is complete.",
                    date: this.formatDate2(new Date()).slice(0, -3)
                })
            }
        })
        .then(async() => {
            const notificationCountRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("notifications")

            await notificationCountRef.get().then(doc => {
                if(doc.exists) {
                    const currentNotificationCount = doc.data().pointsNotificationCount
                    const updatedNotificationCount = currentNotificationCount+1
                    notificationCountRef.update({
                        pointsNotificationCount: updatedNotificationCount
                    })
                }
            })
            await this.loadNotificationCount(this.state.userID)
            this.setState({
                showMyOrdersNotification: false,
                showReceiptVerificationPending: true
            })
        })
    }

    closeReceiptSuccess = () => {
        this.setState({
            showUploadReceiptSuccess: false,
            showUploadReceiptLoading: true,
            showReceiptDateOfPurchase: false,
            showReceiptInvoiceNumber: false,
            showReceiptCaptureDisclaimer: false,
            invoiceNumber: "",
            dateOfIssue: "",
            uploadReceiptDelayText: ""
        }, () => {
            setTimeout(() => {
                this.setState({
                    showUploadReceiptLoading: false,
                    showUploadReceipts: true
                })
            }, 5000)
        })
    }

    retryReceiptUpload = () => {
        this.setState({
            showUploadReceiptFailure: false,
            showUploadReceiptLoading: true,
            uploadReceiptDelayText: "",
            receiptCaptureError1: "",
            receiptCaptureError2: "",
            receiptCaptureError3: "",
            receiptCaptureError4: "",
        }, () => {
            setTimeout(() => {
                this.setState({
                    showUploadReceiptLoading: false,
                    showUploadReceipts: true
                })
            }, 5000)
        })
    }

    createBlobs = () => {
        const container = document.getElementById('blobContainer');
    
        for (let i = 0; i < 5; i++) {
          const blob = document.createElement('div');
          blob.classList.add('blob');
    
          // Set initial random position
          const initialX = Math.random() * 100;
          const initialY = Math.random() * 100;
          blob.style.left = `${initialX}%`;
          blob.style.top = `${initialY}%`;
    
          // Set random animation delay
          const delay = Math.random() * 4;
          blob.style.animationDelay = `-${delay}s`;
    
          container.appendChild(blob);

          this.animateBlob(blob);
        }
    };

    animateBlob = (blob) => {
        const container = document.getElementById('blobContainer');
    
        const updateBlobPosition = () => {
          let currentY = parseFloat(blob.style.top);
    
          // Update position
          currentY += 0.2; // Adjust the falling speed
    
          // Check if the blob is out of the container
          if (currentY > container.offsetHeight) {
            // Reset the blob's position above the container
            blob.style.top = `${-Math.random() * 20}%`;
            blob.style.left = `${Math.random() * 100}%`;
          } else {
            blob.style.top = `${currentY}px`;
          }
        };
    
        const animate = () => {
          updateBlobPosition();
          requestAnimationFrame(animate);
        };
    
        // Start the animation
        animate();
    };

    findDifferenceToNearestReward = (availableRewards, currentPoints) => {
        if (!availableRewards || availableRewards.length === 0) {
            return null; // No available rewards
        }
      
        let nearestReward = null;
        let smallestDifference = Infinity;
      
        for (let i = 0; i < availableRewards.length; i++) {
            const currentReward = availableRewards[i];
        
            // Skip rewards with pointsRewardValue less than or equal to currentPoints
            if (parseInt(currentReward.pointsRewardValue) <= currentPoints) {
                continue;
            }
        
            const difference = Math.abs(currentPoints - parseInt(currentReward.pointsRewardValue));
        
            if (difference < smallestDifference) {
                smallestDifference = difference;
                nearestReward = currentReward;
            }
        }
      
        if (nearestReward !== null) {
            const differenceToNearestReward = Math.abs(currentPoints - nearestReward.pointsRewardValue);
            return differenceToNearestReward;
        } else {
            return null; // No reward with pointsRewardValue above currentPoints
        }
    }

    loadRewards = async () => {
        class Reward {
            constructor(customRewardValue, date, dateAdded, expiryDate, freeItem, id, moneyEquivalentValue, moneyOffValue, newReward, percentageOffValue, pointsRewardValue, rewardMenuCategory, rewardMenuItem, rewardQuantity, rewardType) {
                this.customRewardValue = customRewardValue
                this.date = date
                this.dateAdded = dateAdded
                this.expiryDate = expiryDate
                this.freeItem = freeItem
                this.id = id
                this.moneyEquivalentValue = moneyEquivalentValue
                this.moneyOffValue = moneyOffValue
                this.newReward = newReward
                this.percentageOffValue = percentageOffValue
                this.pointsRewardValue = pointsRewardValue
                this.rewardMenuCategory = rewardMenuCategory
                this.rewardMenuItem = rewardMenuItem
                this.rewardQuantity = rewardQuantity
                this.rewardType = rewardType
            }
            toString () {
                return this.customRewardValue + ', ' +
                this.date + ', ' +
                this.dateAdded + ', ' +
                this.expiryDate + ', ' +
                this.freeItem + ', ' +
                this.id + ', ' +
                this.moneyEquivalentValue + ', ' +
                this.moneyOffValue + ', ' +
                this.newReward + ', ' +
                this.percentageOffValue + ', ' +
                this.pointsRewardValue + ', ' +
                this.rewardMenuCategory + ', ' +
                this.rewardMenuItem + ', ' +
                this.rewardQuantity + ', ' +
                this.rewardType + ', '
            }
        }
        var rewardConverter = {
            toFirestore:function(reward) {
                return {
                    customRewardValue: reward.customRewardValue,
                    date: reward.date,
                    dateAdded: reward.dateAdded,
                    expiryDate: reward.expiryDate,
                    freeItem: reward.freeItem,
                    id: reward.id,
                    moneyEquivalentValue: reward.moneyEquivalentValue,
                    moneyOffValue: reward.moneyOffValue,
                    newReward: reward.newReward,
                    percentageOffValue: reward.percentageOffValue,
                    pointsRewardValue: reward.pointsRewardValue, 
                    rewardMenuCategory: reward.rewardMenuCategory,
                    rewardMenuItem: reward.rewardMenuItem,
                    rewardQuantity: reward.rewardQuantity,
                    rewardType: reward.rewardType,
                }
            },
            fromFirestore:function(snapshot, options) {
                const data = snapshot.data(options)
                return new Reward(data.customRewardValue, data.date, data.dateAdded, data.expiryDate, data.freeItem, data.id, 
                data.moneyEquivalentValue, data.moneyOffValue, data.newReward, data.percentageOffValue, data.pointsRewardValue,
                data.rewardMenuCategory, data.rewardMenuItem, data.rewardQuantity, data.rewardType)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .collection("rewardsList")
        .withConverter(rewardConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => {
                const pointsA = parseInt(a.pointsRewardValue, 10);
                const pointsB = parseInt(b.pointsRewardValue, 10);
                return pointsA - pointsB;
            });
            
            this.setState({
                availableRewards: sortedArray,
                rewardsArrayLoading: false
            })
        })
    }

    isMoreThanThreeDaysApart = (dateString) => {
        // Convert the input date string to a Date object
        const inputDate = new Date(dateString);
        // Get the current date
        const currentDate = new Date();
        // Calculate the difference in milliseconds
        const timeDifference = Math.abs(inputDate - currentDate);
        // Calculate the difference in days
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        // Check if the difference is more than three days
        return daysDifference > 3;
    }

    renderRewards = () => {
        if (this.state.availableRewards.length !== 0) {
            const firstThreeRewards = this.state.availableRewards.slice(0, 3);
            return firstThreeRewards.map(rewards => {
                var {customRewardValue, date, dateAdded, expiryDate, freeItem, id,
                    moneyEquivalentValue, moneyOffValue, newReward, percentageOffValue, 
                    pointsRewardValue, rewardMenuCategory, rewardMenuItem,
                    rewardQuantity, rewardType} = rewards

                    if (this.state.rewardsArrayLoading) {
                         return (
                            <div style={{height: "20vh", textAlign: "center"}} className='upcomingRewardDisplay'>
                                <div style={{paddingTop: "12.5%"}}>
                                    <ClipLoader
                                    color="#321d05"
                                    loading={true}
                                    // cssOverride={override}
                                    size={25}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            </div>
                         )
                    } else {

                        let rewardTitle
                        let rewardPrice

                        let discountPrice
                        let rewardTag

                        let rewardEmoji

                        let rewardStatusEmoji
                        let redeemBtnBgColor
                        let redeemBtnTxtColor
                        let priceTagBgColor 
                        let priceTagTxtColor
                        let showDiscountPrice = true

                        let newRewardLabel 


                        if (newReward === true && !this.isMoreThanThreeDaysApart(dateAdded)) {
                            newRewardLabel = true
                        }

                        if (rewardMenuItem !== "") {

                                //* - - REWARD LOCKED / UNLOCKED - - *//

                            if (this.state.points < parseInt(pointsRewardValue)) {
                                rewardStatusEmoji = "🔒"
                                redeemBtnBgColor = "#BDBDBD"
                                redeemBtnTxtColor = "#717070"
                                priceTagBgColor = "#BDBDBD"
                                priceTagTxtColor = "#717070"
                            } else {
                                rewardStatusEmoji = "🎉"
                                redeemBtnBgColor = "#0930cb"
                                redeemBtnTxtColor = "white"
                                priceTagBgColor = "#321d05"
                                priceTagTxtColor = "white"
                            }

                                //* - - REWARD EMOJI - - *//

                            if (rewardMenuCategory === "coffee_and_tea") {
                                rewardEmoji = this.state.coffeeEmoji
                            } else if (rewardMenuCategory === "breakfast") {
                                rewardEmoji = this.state.eggEmoji
                            } else if (rewardMenuCategory === "pasta") {
                                rewardEmoji = this.state.pastaEmoji
                            } else if (rewardMenuCategory === 'sandwiches') {
                                rewardEmoji = this.state.sandwichEmoji
                            } else if (rewardMenuCategory === "cocktails") {
                                rewardEmoji = this.state.cocktailEmoji
                            } else if (rewardMenuCategory === "burgers") {
                                rewardEmoji = this.state.burgerEmoji
                            } else if (rewardMenuCategory === "lunch_and_dinner") {
                                rewardEmoji = this.state.dishEmoji
                            }

                                //* - - REWARD DETAILS - - *//

                            const match = rewardMenuItem.split("(KES");
                            rewardTitle = match[0];
                            rewardPrice = `(KES${match[1]}`;

                            if (rewardType === "percentage-off") {
                                discountPrice = Math.round((parseInt(match[1]) - (parseInt(match[1]) * (parseInt(percentageOffValue)/100))) / 10) * 10 
                                rewardTag = `${percentageOffValue}% off`
                            } else if (rewardType === "amount-off") {
                                discountPrice = parseInt(match[1]) - parseInt(moneyOffValue);
                                rewardTag = `Save ${moneyOffValue}`
                            } else if (rewardType === "free-item") {
                                discountPrice = 0
                                rewardTag = `100% off`
                            }

                        } else {
                            if (this.state.points < parseInt(pointsRewardValue)) {
                                rewardStatusEmoji = "🔒"
                                redeemBtnBgColor = "#BDBDBD"
                                redeemBtnTxtColor = "#717070"
                                priceTagBgColor = "#BDBDBD"
                                priceTagTxtColor = "#717070"
                            } else {
                                rewardStatusEmoji = "🎉"
                                redeemBtnBgColor = "#0930cb"
                                redeemBtnTxtColor = "white"
                                priceTagBgColor = "#321d05"
                                priceTagTxtColor = "white"
                            }
                            rewardEmoji = this.state.customRewardEmoji
                            rewardTitle = customRewardValue
                            discountPrice = 0
                            showDiscountPrice = false
                            rewardTag = "Special Reward"
                        }

                        return (
                            <div style={{marginBottom: "4%", marginLeft: "5%", backgroundColor: "#f1f2f3"}} className='upcomingRewardDisplay'>
                                <div className='rewardDisplayCol1'>
                                    {newRewardLabel && <span style={{backgroundColor: "#0930cb", fontSize: "10px", color: "white", marginTop: "30%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "1.5%", paddingBottom: "1.5%", borderRadius: "8px", fontWeight: "bold"}}>NEW</span>}
                                    <h1 style={{marginTop: newRewardLabel === true ? "2%" : "25%"}}>{rewardEmoji}</h1>
                                    <span>
                                        <h5 style={{marginTop: "0px", marginBottom: "0px", fontWeight: "bolder", fontFamily: "sora"}}>Points:</h5>
                                    </span>
                                    <span>
                                        <h5 style={{marginTop: "0px", marginBottom: "0px", fontWeight: "bolder"}}>{pointsRewardValue}</h5>
                                    </span>
                                </div>
                                <div className='rewardDisplayCol2'>
                                    <p>{rewardTitle} <s>{rewardPrice}</s></p>
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        {showDiscountPrice && <span style={{backgroundColor: priceTagBgColor, marginRight: "2.5%"}}><h3 style={{color: priceTagTxtColor, fontFamily: "sora"}}>KES {discountPrice}</h3></span>}
                                        <span className='price-tag' style={{position: "relative", border: "2px solid #FF914D", backgroundColor: "#FF914D", borderRadius: "10px", paddingTop: "1%", paddingBottom: "1.5%", paddingLeft: "2.85%", paddingRight: "2.5%", display: "inline-block"}}><label style={{color: '#321d05', marginTop: "8%", marginBottom: "0px", fontFamily: "rubik", fontWeight: "normal"}}>{rewardTag}</label></span>
                                        <h3 style={{marginTop: "0px", marginBottom: "0px", fontSize: "", marginLeft: "2%", paddingTop: "2%"}}>{rewardStatusEmoji}</h3>
                                    </div>
                                    <div style={{marginTop: "4%", paddingBottom: "4%", display: "flex", flexDirection: "column"}}>
                                        <button 
                                        onClick={() => this.openRewardDialog(rewardTitle, rewardPrice, discountPrice, rewardEmoji, rewardTag, id, rewardType, pointsRewardValue, customRewardValue)}
                                        style={{width: "96.5%", height: "40px", fontFamily: "sora", color: redeemBtnTxtColor, borderRadius: "8px", border: `2px solid ${redeemBtnBgColor}`, fontSize: "80%", backgroundColor: redeemBtnBgColor}}
                                        >Redeem
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    
            })
        }
    }

    formatDate2 = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
    
        // Get the time (HH:MM)
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const returnTime = `${hours}:${minutes}:${seconds}`;
    
        return `${month}-${day}-${year} ${returnTime}`;
    };

    openRewardDialog = (rewardTitle, rewardPrice, discountPrice, rewardEmoji, rewardTag, id, rewardType, pointsRewardValue, customRewardValue) => {
        if (this.state.points < parseInt(pointsRewardValue)) {
            this.setState({
                showRewardSelected: true,
                showDialogRewardLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showDialogRewardLoading: false,
                        showDialogMissingPoints: true,
                    })
                }, 2000)
            })
        } else {
            this.setState({
                showRewardSelected: true,
                rewardTitle: rewardTitle,
                rewardPrice: rewardPrice,
                discountPrice: discountPrice,
                rewardEmoji: rewardEmoji,
                rewardTag: rewardTag,
                rewardDate: `${this.formatDate2(new Date()).slice(0, -3)}`,
                rewardDateAndTime: `${this.formatDate2(new Date())}`,
                rewardName: id,
                rewardType: rewardType,
                rewardPointsValue: parseInt(pointsRewardValue),
                customRewardValue: customRewardValue
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showDialogRewardLoading: false,
                        showDialogRewardSuccess: false,
                        showDialogReward: true
                    })
                }, 2000)
            })
        }
    }

    closeRewardDialog = () => {
        this.setState({
            showRewardSelected: false,
            showDialogRewardSuccess: false,
            showDialogMissingPoints: false,
            showDialogRewardLoading: true,
            showDialogReward: false
        })
    }

    closeRewardDialogSuccess = () => {
        this.setState({
            showRedeemConfirmBtns: false,
            showRedeemBtn: true,
            showDialogRewardSuccess: false,
            showDialogRewardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRewardSelected: false
                })
            }, 2000)
        })
    }

    closeRewardDialogMissingPoints = () => {
        this.setState({
            showDialogMissingPoints: false,
            showRewardSelected: false,
        })
    }

    redeemBtnClicked = () => {
        this.setState({
            showRedeemBtn: false,
            showRedeemBtnLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRedeemBtnLoading: false,
                    showRedeemConfirmBtns: true
                })
            }, 2000)
        })
    }

    cancelRedeemReward = () => {
        this.setState({
            showRedeemConfirmBtns: false,
            showRedeemBtnLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRedeemBtnLoading: false,
                    showRedeemBtn: true
                })
            }, 2000)
        })
    }

    pushDataToRewards = async () => {

        let orderDate = this.state.rewardDateAndTime.split(' ')[0];
        let timeDate = this.state.rewardDateAndTime.split(' ')[1];
        let components = orderDate.split('-');
        let timeComponents = timeDate.split(':');
        const newFormatOrderDate = `${components[0]}-${components[1]}-${components[2]}-${timeComponents[0]}-${timeComponents[1]}-${timeComponents[2]}`;

        let rewardID = `${this.state.userID}-${newFormatOrderDate}`;

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(rewardID)
        .set({
            bgColor: "white",
            email: this.state.email,
            id: rewardID,
            name: `${this.state.firstName} ${this.state.lastName}`,
            userID: this.state.userID,   
            date: this.state.rewardDateAndTime, 
            rewardDiscountPrice: this.state.discountPrice,
            rewardName: this.state.rewardName,
            rewardType: this.state.rewardType,
            rewardValue: this.state.rewardTag.replace(/\D/g, ''),
            customRewardValue: this.state.customRewardValue,
            rewardPoints: this.state.rewardPointsValue
        })
        .then(async() => {
            const currentPointsRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("pointsInfo")

            await currentPointsRef.get().then(doc => {
                if (doc.exists) {
                    const currentPoints = doc.data().points
                    const updatedPoints = currentPoints - this.state.rewardPointsValue
                    currentPointsRef.update({
                        points: updatedPoints
                    })
                }
            })

            this.pointsListener = currentPointsRef.onSnapshot(doc => {
                if (doc.exists) {
                    const updatedPoints = doc.data().points;
                    this.setState({
                        points: updatedPoints
                    });
                }
            });
        })
    }

    confirmRedeemReward = async () => {
        this.setState({
            showDialogReward: false,
            showDialogRewardLoading: true
        }) 


        await this.pushDataToRewards()
        this.pushRewardRedeemedNotification()

        this.setState({
            showDialogRewardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showDialogRewardLoading: false,
                    showDialogRewardSuccess: true
                })
            }, 2000)
        })
    }

        //* - - NOTIFICATIONS - - *//

        //* - POINTS - *//

    renderPointsNotifications = () => {
        if (this.state.pointsNotifications.length !== 0) {
            return this.state.pointsNotifications.map(notification => {
                var {date, msg} = notification
                return (   
                    <div className='notificationCell'>
                        <h5 style={{marginBottom: "1.5%", marginTop: "2.25%", marginLeft: "0.5%", marginRight: "0.5%", textAlign: "left", fontFamily: "rubik", color: "#321d05"}}>{date}</h5>
                        <p style={{marginTop: "1.5%"}}>{msg}</p>
                    </div>
                )
            })
        }
    }

    loadPointsNotifications = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("points")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                pointsNotifications: data
            })
        })
    }

    deletePointsNotifications = async () => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("points")
        .get().then(snapshot => {
            snapshot.forEach((doc) => {
                doc.ref.delete()
            })
        })
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .update({
            pointsNotificationCount: 0
        })
    }

    openPointsNotifications = () => {
        this.loadPointsNotifications()
        this.setState({
            showPointsNotificationCount: false,
            showPointsNotificationLoading: true,
            showPointsNotifications: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showPointsNotificationLoading: false,
                    showPointsNotificationClose: true
                })
            }, 2000)
        })
    }

    closePointsNotifications = () => {
        this.deletePointsNotifications()
        this.setState({
            showPointsNotificationClose: false,
            showPointsNotifications: false
        })
    }

        //* - REWARDS - *//

    renderRewardsNotifications = () => {
        if (this.state.rewardsNotifications.length !== 0) {
            return this.state.rewardsNotifications.map(notification => {
                var {date, msg} = notification
                return (   
                    <div className='notificationCell'>
                        <h5 style={{marginBottom: "1.5%", marginTop: "2.25%", marginLeft: "0.5%", marginRight: "0.5%", textAlign: "left", fontFamily: "rubik", color: "#321d05"}}>{date}</h5>
                        <p style={{marginTop: "1.5%"}}>{msg}</p>
                    </div>
                )
            })
        }
    }

    loadRewardsNotifications = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("rewards")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                rewardsNotifications: data
            })
        })
    }

    deleteRewardsNotifications = async () => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("rewards")
        .get().then(snapshot => {
            snapshot.forEach((doc) => {
                doc.ref.delete()
            })
        })
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .update({
            rewardsNotificationCount: 0,
            seenNewReward: "true"
        })
    }

    openRewardsNotifications = () => {
        this.loadRewardsNotifications()
        this.setState({
            showRewardsNotificationCount: false,
            showRewardsNotificationLoading: true,
            showRewardsNotifications: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRewardsNotificationLoading: false,
                    showRewardsNotificationClose: true
                })
            }, 2000)
        })
    }

    closeRewardsNotifications = () => {
        this.deleteRewardsNotifications()
        this.setState({
            showRewardsNotificationClose: false,
            showRewardsNotifications: false
        })
    }

    pushRewardRedeemedNotification = () => {
        const rewardNotificationRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
        .collection("rewards")
        .doc(`notification-${this.state.rewardsNotificationCount+1 || 1}`)

        rewardNotificationRef.get().then(doc => {
            if (doc.exists) {
                rewardNotificationRef.update({
                    msg: `You have successfully redeemed your ${this.state.rewardTitle} reward!`
                })
            } else {
                rewardNotificationRef.set({
                    msg: `You have successfully redeemed your ${this.state.rewardTitle} reward!`,
                    date: this.formatDate2(new Date()).slice(0, -3)
                })
            }
        })
        .then(async() => {
            const notificationCountRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("notifications")

            await notificationCountRef.get().then(doc => {
                if(doc.exists) {
                    const currentNotificationCount = doc.data().rewardsNotificationCount
                    const updatedNotificationCount = currentNotificationCount+1
                    notificationCountRef.update({
                        rewardsNotificationCount: updatedNotificationCount
                    })
                }
            })
            await this.loadNotificationCount(this.state.userID)
        })
    }

        //* - - OFFER CARDS - - *//

    moreInfoCard1Clicked = () => {
        this.setState({
            showOfferCard1: false,
            showOfferCard1Loading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard1Loading: false,
                    showOfferCard1MoreInfo: true
                })
            }, 2000)
        })
    }

    closeMoreInfoCard1Clicked = () => {
        this.setState({
            showOfferCard1MoreInfo: false,
            showOfferCard1MoreInfoLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard1MoreInfoLoading: false,
                    showOfferCard1: true 
                })
            }, 2000)
        })
    }

    moreInfoCard2Clicked = () => {
        this.setState({
            showOfferCard2: false,
            showOfferCard2Loading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard2Loading: false,
                    showOfferCard2MoreInfo: true
                })
            }, 2000)
        })
    }

    closeMoreInfoCard2Clicked = () => {
        this.setState({
            showOfferCard2MoreInfo: false,
            showOfferCard2MoreInfoLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard2MoreInfoLoading: false,
                    showOfferCard2: true 
                })
            }, 2000)
        })
    }

    moreInfoCard3Clicked = () => {
        this.setState({
            showOfferCard3: false,
            showOfferCard3Loading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard3Loading: false,
                    showOfferCard3MoreInfo: true
                })
            }, 2000)
        })
    }

    closeMoreInfoCard3Clicked = () => {
        this.setState({
            showOfferCard3MoreInfo: false,
            showOfferCard3MoreInfoLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOfferCard3MoreInfoLoading: false,
                    showOfferCard3: true 
                })
            }, 2000)
        })
    }

    render () {

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        let verificationBoxStyle = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.emailVerificationBoxShadow}), 0 6px 20px 0 rgba(${this.state.emailVerificationBoxShadow})`
        }

        const titleStyle = {
            // Add your custom font properties here
            fontFamily: 'rubik',
            fontSize: '16px', // Adjust the font size as needed
            fontWeight: 'bold', // Adjust the font weight as needed
            color: "#321d05",
            paddingTop: "0.5%"
            // Add other font properties as needed
        };
        

        return (
            <Styles>
                <div className='fullPage'>
                    <div className='cardContainer'>
                        <Container>
                            <div style={{display: "flex", justifyContent:"space-between"}}>
                                <h3 style={{paddingLeft: "4%", fontFamily: "sora", fontSize: "18.5px", fontWeight: "bold", paddingTop: "2%", color: "white"}}>Hi {this.state.firstName} 👋🏾</h3>
                                <Button onClick={this.toggleDropdown}>
                                    <img className='menu-btn' src='/assets/mobile-smallphone-menu-icon.png'/>
                                </Button>
                            </div>
                            <Dropdown className='dropdown' open={this.state.isDropdownOpen}>
                            <p onClick={this.logout} style={{paddingRight: "2.5%"}}>Logout</p>
                            <p onClick={this.dropdownOption3Clicked} style={{paddingRight: "2.5%"}}> Rewards</p>
                            <p onClick={this.dropdownOption2Clicked} style={{paddingRight: "2.5%"}}>Purchases</p>
                            {/* <p onClick={this.dropdownOption4Clicked} style={{paddingRight: "2.5%"}}>Challenges</p> */}
                            </Dropdown>
                        </Container>
                        <div style={{backgroundColor: this.state.userLoyaltyCardBgColor}} className='userPointsCard'>
                            {this.state.showUserLoyaltyCard && 
                                <div>
                                    <h4>Loyalty Card</h4>
                                    <h3>{this.state.firstName.toUpperCase()} {this.state.lastName.toUpperCase()}</h3>
                                    <div className='userPointsCardInnerContainer'>
                                        <div className='userPointsCardIcon'>
                                            <img src='/assets/rewardCardIcon.png'/>
                                        </div>
                                        <div className='userPointsCardDetails'>
                                            <h1>{Math.round(this.state.points)} Points</h1>
                                            {this.state.userLoyaltyCardShowPointsRemaining && 
                                                <p>{this.state.pointsTillNextReward} points till next reward</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='userPointsCardFooter'>
                                        <div className='userPointsCardLogo'>
                                            <img style={{borderRadius: "8px"}} src='/assets/artcaffe-logo.jpg'/>
                                        </div>
                                        {this.state.userLoyaltyCardShowCardNumber && 
                                            <div className='userPointsCardNumber'>
                                                <p>{this.renderCardNumber()}</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {this.state.showUserLoyaltyCardLoading && 
                                <div className='userLoyaltyCardLoading'>
                                    <ClipLoader
                                    color="#321d05"
                                    loading={true}
                                    // cssOverride={override}
                                    size={40}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            }
                        </div>
                        <div id='topOfEmailVerification'></div>
                    </div>
                    {this.state.showHomeScreen && 
                        <div>
                            {this.state.showEmailVerification && 
                                <div className='emailVerificationContainer'>
                                    <div style={verificationBoxStyle} className='invitationCard'>
                                        <img src='/assets/email-verification-error.png'/>
                                        <h4>Email Verification</h4>
                                        <h3>{this.state.email}</h3>
                                        <p>To start earning points, your email must be verified.</p>
                                        <button
                                        onClick={this.verifyEmailClicked}
                                        className='verifyEmailBtn'
                                        >
                                            {this.state.showConfirmVerificationBtnText && 
                                                <span>Verify Email</span>
                                            }
                                            {this.state.showConfirmVerificationBtnLoading && 
                                                <span className='verifyBtnLoader'>
                                                    <ClipLoader
                                                    color="#0930cb"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={17.5}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            }
                            {this.state.showEmailVerificationLoading && 
                                <div style={{marginTop: "6.5%"}} className='invitationCard'>
                                    <div className='emailVerificationLoading'>
                                        <ClipLoader
                                        color="#0930cb"
                                        loading={true}
                                        // cssOverride={override}
                                        size={30}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                </div>
                            }
                            {this.state.showEmailVerificationPending && 
                                <div className='emailVerificationContainer'>
                                    <div style={verificationBoxStyle} className='invitationCard'>
                                        <img src='/assets/verification-pending.png'/>
                                        <h4>Email Verification Sent</h4>
                                        <h3>{this.state.email}</h3>
                                        <p>Check your inbox to verify your email.</p>
                                        <button
                                        onClick={this.verifyConfirmationClicked}
                                        className='verifyEmailBtn'
                                        >Confirm Verification</button>
                                    </div>
                                </div>
                            }
                            {this.state.showEmailVerificationSuccess && 
                                <div className='emailVerificationContainer'>
                                    <div className='invitationCard'>
                                        <img src='/assets/checkmark_publishedOffers.png'/>
                                        <h4>Email Verification Success</h4>
                                        <h3>{this.state.email}</h3>
                                        <p>Your email is now verified.</p>
                                        {/* <p>If you longer see this notification, your email is successfully verified.</p> */}
                                        <button
                                        onClick={this.closeEmailVerification}
                                        className='verifyEmailBtn'
                                        >Close</button>
                                    </div>
                                </div>
                            }
                            {this.state.showEarningPolicyButton && 
                                <div className='earningPolicyContainer2'>
                                    <button
                                    onClick={this.checkIfEarningPoliciesApply}
                                    >You've unlocked an earning booster!</button>
                                    <p style={{color: "#0930cb", marginTop: "2%", fontFamily: "gabarito"}}>(click to activate)</p>
                                </div>
                            }
                            {this.state.showEarningPolicyChecking && 
                                <div className='earningPolicyContainer2'>
                                    <div style={{paddingTop: "9.5%", paddingBottom: "9.5%"}}>
                                        <ClipLoader
                                        color="#0930cb"
                                        loading={true}
                                        // cssOverride={override}
                                        size={30}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                </div>
                            }
                            {this.state.showEarningPolicy && 
                                <div className='earningPolicyContainer' id="blobContainer">
                                        <div className='earningPolicyTopMsg'>
                                            <p style={{marginBottom: "0px", paddingBottom: "0px"}}>You've unlocked a boost!</p>
                                            <span><p style={{marginTop: "0px", fontWeight: "bold", fontSize: "12px"}}>Valid till. [{this.state.earningPolicyEndDate}]</p></span>
                                        </div>  
                                    <div className='earningPolicyImg'>
                                        <h1 className='levitating-h1'>🚀</h1>
                                    </div>
                                    <div className='earningPolicyInfo'>
                                        <button><h1>↑ {this.state.earningPolicyPercentageChange}%</h1></button>
                                        <label>on buy value</label>
                                    </div>
                                    <div className='earningPolicyBottomMsg'>
                                        {/* <p>Valid till. [12/10/2023]</p> */}
                                    </div>
                                    {/* <div class="blob"></div>
                                    <div class="blob"></div> */}
                                </div>
                            }
                            <div className='shareCodeContainer'>
                                <div style={{borderBottom: "1px solid #321d05", marginBottom: "5%", marginLeft: "5%", marginRight: "5%"}}></div>
                                <div className='upcomingRewardsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                                    <h2 style={{display: "inline-block", marginTop: "1%", color: "#321d05", fontFamily: "arvo", marginLeft: "5%"}}>Points</h2>
                                    <div className='pointsNotification' style={{marginRight: "6%"}}>
                                        {this.state.showPointsNotificationCount && 
                                            <button 
                                            onClick={this.openPointsNotifications}
                                            style={
                                                {   
                                                    marginLeft: "15%",
                                                    height:"65%",
                                                    fontSize: "85%",
                                                    fontFamily: "sora",
                                                    color: "#321d05",
                                                    fontWeight: "normal",
                                                    borderRadius: "30px",
                                                    border: "0.5px solid #FF914D",
                                                    backgroundColor: "#FF914D"
                                                }
                                            }>{this.state.pointsNotificationCount}</button>
                                        }
                                        {this.state.showPointsNotificationLoading && 
                                            <button style={
                                                {   
                                                    marginLeft: "15%",
                                                    height:"65%",
                                                    fontSize: "85%",
                                                    fontFamily: "sora",
                                                    color: "#321d05",
                                                    fontWeight: "bold",
                                                    borderRadius: "30px",
                                                    border: "0.5px solid #FF914D",
                                                    backgroundColor: "#FF914D"
                                                }       
                                            }>
                                                <ClipLoader
                                                color="#321d05"
                                                loading={true}
                                                // cssOverride={override}
                                                size={5}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </button>
                                        }
                                        {this.state.showPointsNotificationClose && 
                                            <button 
                                            onClick={this.closePointsNotifications}
                                            style={
                                                {   
                                                    marginLeft: "15%",
                                                    height:"65%",
                                                    fontSize: "85%",
                                                    fontFamily: "sora",
                                                    color: "#321d05",
                                                    fontWeight: "normal",
                                                    borderRadius: "30px",
                                                    border: "0.5px solid #FF914D",
                                                    backgroundColor: "#FF914D"
                                                }
                                            }>Close</button>
                                        }
                                    </div>
                                </div>
                                <CSSTransition
                                in={this.state.showPointsNotificationClose}
                                timeout={300} // Set the duration of the animation (in milliseconds)
                                classNames="notification"
                                unmountOnExit
                                >
                                    <div style={{marginBottom: "7.5%"}}>
                                        <h4 style={
                                            {
                                                marginTop: "0px", 
                                                marginBottom: "2%",
                                                textAlign: "left", 
                                                marginLeft: "5%",
                                                fontFamily: "arvo",
                                                color: "#321d05"

                                            }
                                        }>Notifications</h4>
                                        {this.renderPointsNotifications()}
                                    </div>
                                </CSSTransition>
                                <div className='invitationCard'>
                                    <h2>{this.state.invitationCardHeader}</h2>
                                    <p>{this.state.invitationCardText}</p>
                                    <div className='invitationCardBtn'>
                                        <button 
                                        onClick={this.shareReferralCodeClicked}
                                        >Share Code</button>
                                    </div>
                                </div>
                            </div>
                            {this.state.showUploadReceipts && 
                                <div style={{marginTop: "0px"}}>
                                    <div className='uploadReceiptContainer'>
                                        {/* <h3>OR</h3> */}
                                        <img src='/assets/upload-receipt-icon2.png'/>
                                        <p style={{fontFamily: "arvo"}}>Upload a picture of your receipt</p>
                                        <button
                                        style={{fontFamily: "sora"}}
                                        onClick={this.uploadReceiptClicked}
                                        >Upload</button>
                                        <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        ref={(input) => (this.fileInput = input)} // Reference to the hidden input
                                        onChange={(e) => this.handleReceiptImageUpload(e.target.files[0])}
                                        />
                                    </div>
                                </div>
                            }
                            {this.state.showUploadReceiptUploading && 
                                <div style={{marginTop: "6.5%"}}>
                                    <div className='uploadReceiptContainer'>
                                        <p style={{marginTop: "5%"}}>{this.state.uploadingReceiptText}</p>
                                        <div className='uploadContainerLoader'>
                                            <BarLoader
                                            // style={{margin: "auto", display: "flex", width: "10%"}}
                                            color="#fff"
                                            loading={true}
                                            // cssOverride={override}
                                            size={15}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                        <p style={{fontWeight: "normal", fontFamily: "gabarito"}}>{this.state.uploadReceiptDelayText}</p>
                                    </div>
                                </div>
                            }
                            {this.state.showUploadReceiptSuccess && 
                                <div style={{marginTop: "0px"}}>
                                    <div className='uploadReceiptContainer'>
                                        <h3>Uploaded Successfully</h3>
                                        <img src='/assets/checkmark_publishedOffers3.png'/>
                                        <p style={{paddingLeft: "3.5%", paddingRight: "3.5%"}}>Once reviewed your points will be updated.</p>
                                        <button
                                        onClick={this.closeReceiptSuccess}
                                        >Close</button>
                                        {this.state.showReceiptInvoiceNumber && <p style={{textAlign: "left", marginLeft: "5%", color: "#fff", fontFamily: "gabarito", fontWeight: "normal"}}>Invoice no.: <label style={{color: "white"}}>{this.state.invoiceNumber}</label></p>}
                                        {this.state.showReceiptDateOfPurchase && <p style={{textAlign: "left", marginLeft: "5%", color: "#fff", fontFamily: "gabarito", fontWeight: "normal"}}>Date of purchase: <label style={{color: "white"}}>{this.state.dateOfIssue}</label></p>}
                                        <p style={{textAlign: "left", marginLeft: "5%", color: "#fff", fontFamily: "gabarito"}}>NOTE: Your receipt is under review by our team and your points will be updated shortly.</p>
                                        {this.state.showReceiptCaptureDisclaimer && <p style={{textAlign: "left", marginLeft: "5%", color: "#fff", fontFamily: "gabarito", fontSize: "13px", fontWeight: "normal"}}>If your invoice no. OR date of purchase was captured incorrectly - our team will rectify it during our review.</p>}
                                    </div>
                                </div>
                            }
                            {this.state.showUploadReceiptFailure && 
                                <div style={{marginTop: "0px"}}>
                                    <div className='uploadReceiptContainer'>
                                        <h3>Something went wrong</h3>
                                        <img src='/assets/cross_publishedOffers.png'/>
                                        <p>{this.state.uploadReceiptErrorMessage}</p>
                                        <button
                                        onClick={this.retryReceiptUpload}
                                        >Try again</button>
                                        <div style={{paddingBottom: "3%"}} className='captureReceiptFailure'>
                                            <p style={{textAlign: "left", fontWeight: "normal"}}>{this.state.receiptCaptureError1}</p>
                                            <p style={{textAlign: "left", fontWeight: "normal"}}>{this.state.receiptCaptureError2}</p>
                                            <p style={{textAlign: "left", fontWeight: "normal"}}>{this.state.receiptCaptureError3}</p>
                                            <p style={{textAlign: "left", fontWeight: "normal"}}>{this.state.receiptCaptureError4}</p>
                                        </div>
                                    </div>
                                    
                                </div>
                            }
                            {this.state.showUploadReceiptLoading && 
                                <div style={{marginTop: "0px"}}>
                                    <div className='uploadReceiptContainer'>
                                        <div className='emailVerificationLoading'>
                                            <ClipLoader
                                            color="#fff"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='upcomingRewardsContainer'>
                                <div className='upcomingRewardsContent'>
                                    <div style={{borderBottom: "1px solid #321d05", marginBottom: "7.5%", paddingTop: "2.5%", marginLeft: "5%", marginRight: "5%"}}></div>
                                    <div className='upcomingRewardsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                                        <h2 style={{display: "inline-block", marginTop: "1%", color: "#321d05", fontFamily: "arvo", marginLeft: "5%"}}>Rewards & Offers</h2>
                                        <div className='pointsNotification' style={{marginRight: "6%"}}>
                                            {this.state.showRewardsNotificationCount && 
                                                <button 
                                                onClick={this.openRewardsNotifications}
                                                style={
                                                    {   
                                                        marginLeft: "15%",
                                                        height:"65%",
                                                        fontSize: "85%",
                                                        fontFamily: "sora",
                                                        color: "#321d05",
                                                        fontWeight: "normal",
                                                        borderRadius: "30px",
                                                        border: "0.5px solid #FF914D",
                                                        backgroundColor: "#FF914D"
                                                    }
                                                }>{this.state.rewardsNotificationCount}</button>
                                            }
                                            {this.state.showRewardsNotificationLoading && 
                                                <button style={
                                                    {   
                                                        marginLeft: "15%",
                                                        height:"65%",
                                                        fontSize: "85%",
                                                        fontFamily: "sora",
                                                        color: "#321d05",
                                                        fontWeight: "bold",
                                                        borderRadius: "30px",
                                                        border: "0.5px solid #FF914D",
                                                        backgroundColor: "#FF914D"
                                                    }       
                                                }>
                                                    <ClipLoader
                                                    color="#321d05"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={5}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </button>
                                            }
                                            {this.state.showRewardsNotificationClose && 
                                                <button 
                                                onClick={this.closeRewardsNotifications}
                                                style={
                                                    {   
                                                        marginLeft: "15%",
                                                        height:"65%",
                                                        fontSize: "85%",
                                                        fontFamily: "sora",
                                                        color: "#321d05",
                                                        fontWeight: "normal",
                                                        borderRadius: "30px",
                                                        border: "0.5px solid #FF914D",
                                                        backgroundColor: "#FF914D"
                                                    }
                                                }>Close</button>
                                            }
                                        </div>
                                    </div>
                                    <CSSTransition
                                    in={this.state.showRewardsNotificationClose}
                                    timeout={300} // Set the duration of the animation (in milliseconds)
                                    classNames="notification"
                                    unmountOnExit
                                    >
                                        <div style={{marginBottom: "7.5%"}}>
                                            <h4 style={
                                                {
                                                    marginTop: "0px", 
                                                    marginBottom: "2%",
                                                    textAlign: "left", 
                                                    marginLeft: "5%",
                                                    fontFamily: "arvo",
                                                    color: "#321d05"

                                                }
                                            }>Notifications</h4>
                                            {this.renderRewardsNotifications()}
                                        </div>
                                    </CSSTransition>
                                    {this.renderRewards()}
                                </div>
                                <CSSTransition
                                in={this.state.showRewardSelected}
                                timeout={500}
                                classNames="dialog-slide"
                                unmountOnExit
                                >
                                    <Dialog
                                    visible={this.state.showRewardSelected}
                                    onClose={this.closeRewardDialog}
                                    title={<div style={titleStyle}>{this.state.rewardHeader}</div>}
                                    // style={{backgroundColor: "#f1f2f3"}}
                                    >   {this.state.showDialogReward &&
                                            <div>
                                                <div>
                                                    <p style={{marginTop: "0px", marginBottom: "0px", textAlign: "right", fontFamily: "sora", color: "#0930cb", fontWeight: "normal"}}>{this.state.rewardDate}</p>
                                                    <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "1.5%", marginBottom: "0px"}}>How to redeem this reward:</h3>
                                                    <p style={{fontFamily: "sora", fontSize: "95%", marginTop: "1%"}}>Before you redeem your reward, close this popup and re-open it in front of your server.</p>
                                                </div>
                                                <div>
                                                    <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "1.5%", marginBottom: "1%"}}>Your Reward:</h3>
                                                    <h1 style={{fontSize: "475%", marginBottom: "1%", marginTop: "1%", textAlign: "center"}}>{this.state.rewardEmoji}</h1>
                                                    <p style={{fontFamily: "sora", marginTop: "1%", marginBottom: "0px", fontSize: "105%"}}>{this.state.rewardTitle} <s>{this.state.rewardPrice}</s></p>
                                                    <div style={{display: "flex", flexDirection: "row", marginBottom: "2%", marginTop: "0.5%"}}>
                                                        <h3 style={{marginTop: "2.75%", color: "#0930cb", fontWeight: "bold", marginRight: "1%", fontFamily: "gabarito", marginBottom: "0px"}}>PRICE: </h3>
                                                        <h3 style={
                                                            { 
                                                                borderRadius: "7px",
                                                                marginLeft: "2%",
                                                                fontFamily: "sora", 
                                                                backgroundColor: "#321d05", 
                                                                color: "white", 
                                                                marginTop: "1%", 
                                                                display: "inline-block",
                                                                paddingTop: "1.5%",
                                                                paddingBottom: "1.5%",
                                                                paddingLeft: "2.5%",
                                                                paddingRight: "2.5%",
                                                                marginBottom: "0px"
                                                            }
                                                            }>KES {this.state.discountPrice}</h3>
                                                    </div>
                                                    <div style={{display: "flex", flexDirection: "row"}}>
                                                        <h3 style={{marginTop: "1.5%", marginBottom: "0px", color: "#0930cb", fontWeight: "bold", marginRight: "1%", fontFamily: "gabarito"}}>DISCOUNT: </h3>
                                                        <label style={{border: "2px solid #FF914D", backgroundColor: "#FF914D", color: "#321d05", marginTop: "0px", marginLeft: "2%", borderRadius: "10px", paddingTop: "1.5%", paddingBottom: "2%", paddingLeft: "2.5%", paddingRight: "2.5%", marginBottom: "0px"}}>{this.state.rewardTag}</label>
                                                    </div>
                                                    {this.state.showRedeemBtn && 
                                                        <div style={{textAlign: "center", marginTop: "5%"}}>
                                                            <button
                                                            onClick={this.redeemBtnClicked}
                                                            style={
                                                                {
                                                                    width: "70%",
                                                                    backgroundColor: "#0930cb",
                                                                    fontFamily: "sora",
                                                                    paddingTop: "5%",
                                                                    paddingBottom: "5%",
                                                                    borderRadius: "30px",
                                                                    color: "white",
                                                                    fontSize: "100%",
                                                                    border: "2px solid #0930cb"
                                                                }
                                                            }
                                                            >Redeem</button>
                                                        </div>
                                                    }
                                                    {this.state.showRedeemBtnLoading && 
                                                        <div style={{textAlign: "center", marginTop: "5%"}}>
                                                            <button
                                                            style={
                                                                {
                                                                    width: "70%",
                                                                    backgroundColor: "#0930cb",
                                                                    fontFamily: "sora",
                                                                    paddingTop: "5%",
                                                                    paddingBottom: "5%",
                                                                    borderRadius: "30px",
                                                                    color: "white",
                                                                    fontSize: "100%",
                                                                    border: "2px solid #0930cb"
                                                                }
                                                            }
                                                            >
                                                                <ClipLoader
                                                                color="#fff"
                                                                loading={true}
                                                                // cssOverride={override}
                                                                size={15}
                                                                aria-label="Loading Spinner"
                                                                data-testid="loader"
                                                                />
                                                            </button>
                                                        </div>
                                                    }
                                                    {this.state.showRedeemConfirmBtns && 
                                                        <div>
                                                            <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%"}}>Confirm your choice:</h3>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <button
                                                                style={{
                                                                    width: "35%", 
                                                                    backgroundColor: "#dfdfdf",
                                                                    border: "2px solid #dfdfdf", 
                                                                    color: "red", 
                                                                    borderRadius: "30px",
                                                                    fontFamily: "sora",
                                                                    padding: "3%",
                                                                    fontSize: "95%"
                                                                }}
                                                                onClick={this.cancelRedeemReward}
                                                                >Cancel</button>
                                                                <button
                                                                style={{
                                                                    width: "35%", 
                                                                    backgroundColor: "#0930cb", 
                                                                    border: "2px solid #0930cb", 
                                                                    color: "#fff", 
                                                                    borderRadius: "30px",
                                                                    fontFamily: "sora",
                                                                    padding: "3%",
                                                                    fontSize: "95%"
                                                                }}
                                                                onClick={this.confirmRedeemReward}
                                                                >Confirm</button>
                                                            </div>
                                                            <div>
                                                                
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {this.state.showDialogRewardLoading && 
                                            <div style={{textAlign: "center", marginTop: "10%", marginBottom: "10%"}}>
                                                <ClipLoader
                                                color="#321d05"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                        {this.state.showDialogRewardSuccess && 
                                            <div>
                                                <div style={{textAlign: "center"}}>
                                                    <img style={{width: "20%"}} src='/assets/checkmark_publishedOffers3.png'/>
                                                </div>
                                                <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%", textAlign: "center"}}>You've successfully redeemed your reward.</h3>
                                                <div style={{textAlign: "center", marginTop: "5%"}}>
                                                    <button
                                                    onClick={this.closeRewardDialogSuccess}
                                                    style={
                                                        {
                                                            width: "70%",
                                                            backgroundColor: "#321d05",
                                                            fontFamily: "sora",
                                                            paddingTop: "5%",
                                                            paddingBottom: "5%",
                                                            borderRadius: "30px",
                                                            color: "white",
                                                            fontSize: "100%",
                                                            border: "2px solid #321d05"
                                                        }
                                                    }
                                                    >Close</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showDialogMissingPoints && 
                                            <div style={{textAlign: "center"}}>
                                                <div style={{textAlign: "center"}}>
                                                    <img style={{width: "20%"}} src='/assets/smallPhone_missingPoints.png'/>
                                                </div>
                                                <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%", textAlign: "center"}}>You don't have enough points to redeem this reward.</h3>
                                                <div style={{textAlign: "center", marginTop: "5%"}}>
                                                    <button
                                                    onClick={this.closeRewardDialogMissingPoints}
                                                    style={
                                                        {
                                                            width: "70%",
                                                            backgroundColor: "#321d05",
                                                            fontFamily: "sora",
                                                            paddingTop: "5%",
                                                            paddingBottom: "5%",
                                                            borderRadius: "30px",
                                                            color: "#fff",
                                                            fontSize: "100%",
                                                            border: "2px solid #321d05"
                                                        }
                                                    }
                                                    >Close</button>
                                                </div>
                                            </div>
                                        }
                                    </Dialog>
                                </CSSTransition>
                            </div>
                            {/* <div className='recentPurchasesContainer'>
                                <div className='recentPurchasesContent'>
                                    <h3>Recent Purchases</h3>
                                    {this.renderRecentActivityCell()}
                                </div>
                            </div> */}
                            <div className='latestOffersContainer'>
                                <div className='latestOffersContent'>
                                    {/* <h3>Latest Offers</h3> */}
                                    {/* <p></p> */}
                                    <Slider className='carousel-container' {...settings}>
                                        <div className='offerCardContainer'>
                                            {this.state.showOfferCard1 && 
                                                <div className='offerCard'>
                                                    <h2><u>{this.state.firstPromoText}</u></h2>
                                                    <div className='offerCardLabel'>
                                                        <label>{this.state.firstPromoSubtext}</label>
                                                    </div>
                                                    <div className='offerCardBtn'>
                                                        <button
                                                        onClick={this.moreInfoCard1Clicked}
                                                        >More info</button>
                                                    </div>
                                                    <h4>OR</h4>
                                                    <p>{this.state.firstPromoMiniText}</p>
                                                    <img src={this.state.firstPromoImg}/> 
                                                </div>
                                            }
                                            {this.state.showOfferCard1Loading && 
                                                <div style={{height: "500px"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#fff"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard1MoreInfo && 
                                                <div className='previewOfferCardMoreInfo'>
                                                    <h3>More details</h3>
                                                    <div>
                                                        <textarea
                                                        id='secondPromoMoreInfoText'
                                                        readOnly={true}
                                                        // onChange={this.handleChange}
                                                        value={this.state.firstPromoMoreInfoText}
                                                        />
                                                    </div>
                                                    <div style={{textAlign: "right", marginRight: "1.5%", marginTop: "1%"}}>
                                                        <button
                                                        onClick={this.closeMoreInfoCard1Clicked}
                                                        >Close</button>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard1MoreInfoLoading && 
                                                <div style={{height: "500px", backgroundColor: "#fff"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#321d05"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className='offerCardContainer'>
                                            {this.state.showOfferCard2 && 
                                                <div className='offerCard'>
                                                    <h2><u>{this.state.secondPromoText}</u></h2>
                                                    <div className='offerCardLabel'>
                                                        <label>{this.state.secondPromoSubtext}</label>
                                                    </div>
                                                    <div className='offerCardBtn'>
                                                        <button
                                                        onClick={this.moreInfoCard2Clicked}
                                                        >More info</button>
                                                    </div>
                                                    <h4>OR</h4>
                                                    <p>{this.state.secondPromoMiniText}</p>
                                                    <img src={this.state.secondPromoImg}/> 
                                                </div>
                                            }
                                            {this.state.showOfferCard2Loading && 
                                                <div style={{height: "500px"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#fff"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard2MoreInfo && 
                                                <div className='previewOfferCardMoreInfo'>
                                                    <h3>More details</h3>
                                                    <div>
                                                        <textarea
                                                        id='secondPromoMoreInfoText'
                                                        readOnly={true}
                                                        // onChange={this.handleChange}
                                                        value={this.state.secondPromoMoreInfoText}
                                                        />
                                                    </div>
                                                    <div style={{textAlign: "right", marginRight: "1.5%", marginTop: "1%"}}>
                                                        <button
                                                        onClick={this.closeMoreInfoCard2Clicked}
                                                        >Close</button>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard2MoreInfoLoading && 
                                                <div style={{height: "500px", backgroundColor: "#fff"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#321d05"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className='offerCardContainer'>
                                            {this.state.showOfferCard3 && 
                                                <div className='offerCard'>
                                                    <h2><u>{this.state.thirdPromoText}</u></h2>
                                                    <div className='offerCardLabel'>
                                                        <label>{this.state.thirdPromoSubtext}</label>
                                                    </div>
                                                    <div className='offerCardBtn'>
                                                        <button
                                                        onClick={this.moreInfoCard3Clicked}
                                                        >More info</button>
                                                    </div>
                                                    <h4>OR</h4>
                                                    <p>{this.state.thirdPromoMiniText}</p>
                                                    <img src={this.state.thirdPromoImg}/> 
                                                </div>
                                            }
                                            {this.state.showOfferCard3Loading && 
                                                <div style={{height: "500px"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#fff"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard3MoreInfo && 
                                                <div className='previewOfferCardMoreInfo'>
                                                    <h3>More details</h3>
                                                    <div>
                                                        <textarea
                                                        id='secondPromoMoreInfoText'
                                                        readOnly={true}
                                                        // onChange={this.handleChange}
                                                        value={this.state.thirdPromoMoreInfoText}
                                                        />
                                                    </div>
                                                    <div style={{textAlign: "right", marginRight: "1.5%", marginTop: "1%"}}>
                                                        <button
                                                        onClick={this.closeMoreInfoCard3Clicked}
                                                        >Close</button>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showOfferCard3MoreInfoLoading && 
                                                <div style={{height: "500px", backgroundColor: "#fff"}} className='offerCard'>
                                                    <div style={{marginTop: "62.5%"}}>
                                                        <ClipLoader
                                                        color="#321d05"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={35}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className='moreOptionsContainer'>
                                <div style={{borderBottom: "1px solid #321d05", marginBottom: "7.5%", paddingTop: "2.5%", marginLeft: "5%", marginRight: "5%"}}></div>
                                <div className='moreOptionsContent'>
                                    <div className='upcomingRewardsHeader' style={{textAlign: "left"}}>
                                        <h2 style={{display: "inline-block", marginTop: "1%", color: "#321d05", fontFamily: "arvo"}}>More Options</h2>
                                    </div>
                                    <div className='challengesContainer'>
                                        <div 
                                        className='challengeBox'
                                        onClick={this.pointsRewardsClicked}
                                        >
                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                <h2>🎉</h2>
                                                {this.state.showMoreRewardsNotification && 
                                                    <img style={{width: "15px", height: "15px", marginTop: "3.5%", marginRight: "3.5%"}} src='/assets/smallPhone_notification.png'/>
                                                }
                                            </div>
                                            <p>More Rewards</p>
                                        </div>
                                        <div 
                                        style={{marginLeft: "5%"}}
                                        className='challengeBox'
                                        onClick={this.challengesClicked}
                                        >
                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                <h2>💳</h2>
                                                {this.state.showReceiptVerificationPending && 
                                                    <img style={{width: "15px", height: "15px", marginTop: "3.5%", marginRight: "3.5%"}} src='/assets/smallPhone_pointsPending.png'/>    
                                                }
                                                {this.state.showMyOrdersNotification && 
                                                    <img style={{width: "15px", height: "15px", marginTop: "3.5%", marginRight: "3.5%"}} src='/assets/smallPhone_notification.png'/>
                                                }
                                            </div>
                                            <p>My Orders</p>
                                        </div>
                                        {/* <div 
                                        className='challengeBox'
                                        // onClick={this.earningChartClicked}
                                        >
                                            <h1>💎</h1>
                                            <h2>Earning Chart</h2>
                                        </div> */}
                                    </div>
                                    <div className='challengesContainer'>
                                        {/* <div 
                                        className='challengeBox'
                                        onClick={this.wishListClicked}
                                        >
                                            <h1>💫</h1>
                                            <h2>Wish List</h2>
                                        </div>
                                        <div
                                        className='challengeBox'
                                        onClick={this.secretMenuClicked}
                                        >
                                            <h1>🤫</h1>
                                            <h2>Secret Menu</h2>
                                        </div> */}
                                        {/* <div 
                                        className='challengeBox'
                                        onClick={this.challengeBox6Clicked}
                                        >
                                            <h1>🎷</h1>
                                            <h2>Music</h2>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.showHomeScreenLoading && 
                        <div className='homescreenLoading'>
                            <GridLoader
                            color="#321d05"
                            loading={true}
                            // cssOverride={override}
                            size={7.5}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                    <div className='footer'>
                        <p>© 2024</p>
                    </div>
                </div>
            </Styles>
        )
    }
}